<template>
  <div v-if="mode != 'done'" class="login bg-banner d-flex flex-column flex-column-fluid flex-lg-row">
    <div class="d-flex flex-center w-lg-50 pt-15 pt-lg-0 px-10">
      <div class="d-flex flex-center flex-lg-start flex-column">
        <a class="mb-7 ">
          <img alt="Logo" class="h-25px" src="/img/Mizuho_logo.svg.png">
        </a>
        <h1 class="text-white m-0" style="text-shadow: 0 0 10px #777">
          <span style="font-size:150%">MeDP</span> (Mizuho electronic Document Platform)
        </h1>
      </div>
    </div>
    <div class="d-flex flex-center w-lg-50 p-10">
      <div class="card rounded-3 w-md-550px">
        <!-- mode: changepw -->
        <div class="card-body p-10 p-lg-20" v-if="mode == 'changepw'">
          <div class="text-center mb-11">
            <h1 class="text-dark fw-bolder mb-3" v-text="$t('비밀번호 변경')" />
          </div>
          <div class="fv-row mb-5 fv-plugins-icon-container">
            <input v-b-tooltip.html="$t('영문자, 숫자 포함시 10 ~ 30자리입니다.<br>영문자,숫자, 특수문자 포함시 8 ~ 30자리입니다.<br>특수문자는 @, _, -, ., $, !, %, *, #, ?, &가 가능합니다.')" maxlength="100" type="password" v-model="pwd.pwd" :placeholder="$t('새 비밀번호')"
              class="form-control bg-transparent">
          </div>
          <div class="fv-row mb-8 fv-plugins-icon-container">
            <input maxlength="100" type="password" v-model="pwd.pwdConf" :placeholder="$t('새 비밀번호 확인')" class="form-control bg-transparent"
              @keyup.enter="changeInitPwd" />
          </div>
          <div v-if="!agree" class="text-gray-500 fw-semibold mb-5 text-center">
            <div class="d-inline form-switch form-check-sm form-check-custom form-check-solid me-2">
              <input type="checkbox" readonly="readonly" id="_check_agree" class="form-check-input me-2" v-model="agree">
              <label for="_check_agree" v-text="$t('서비스 이용에 동의합니다.')" />
            </div>(<a class="text-primary" v-b-modal.설명 v-text="$t('설명')" />)
          </div>
          <div class="d-grid mb-10">
            <button @click="changeInitPwd" :disabled="!agree" class="btn btn-primary" v-text="$t('비밀번호 변경')" />
          </div>
        </div>
        <!-- mode: findpw -->
        <div class="card-body p-10 p-lg-20" v-else-if="mode == 'findpw'">
          <div class="text-center mb-11">
            <h1 class="text-dark fw-bolder mb-3" v-text="$t('비밀번호 찾기')" />
          </div>
          <div class="fv-row mb-5 fv-plugins-icon-container">
            <input maxlength="100" type="text" :placeholder="$t('아이디')" v-model="find.userId"
              class="form-control bg-transparent">
          </div>
          <div class="fv-row mb-12 fv-plugins-icon-container">
            <input maxlength="100" type="email" :placeholder="$t('이메일')" v-model="find.email"
              class="form-control bg-transparent">
          </div>
          <div class="d-grid mb-10">
            <button @click="findIdPwd('Pwd')" class="btn btn-primary" v-text="$t('비밀번호 찾기')" />
          </div>
          <div class="text-gray-500 text-center fw-semibold fs-6">
            <a @click="mode = 'login'" class="link-primary" v-text="$t('로그인')" />
          </div>
        </div>
        <!-- mode: findid -->
        <div class="card-body p-10 p-lg-20" v-else-if="mode == 'findid'">
          <div class="text-center mb-11">
            <h1 class="text-dark fw-bolder mb-3" v-text="$t('아이디 찾기')" />
          </div>
          <div class="fv-row mb-5 fv-plugins-icon-container">
            <input maxlength="100" type="text" :placeholder="$t('이름')" v-model="find.userNm"
              class="form-control bg-transparent">
          </div>
          <div class="fv-row mb-12 fv-plugins-icon-container">
            <input maxlength="100" type="email" :placeholder="$t('이메일')" v-model="find.email"
              class="form-control bg-transparent">
          </div>
          <div class="d-grid mb-10">
            <button @click="findIdPwd('Id')" class="btn btn-primary" v-text="$t('아이디 찾기')" />
          </div>
          <div class="text-gray-500 text-center fw-semibold fs-6">
            <a @click="mode = 'login'" class="link-primary" v-text="$t('로그인')" />
          </div>
        </div>
        <!-- mode: login -->
        <div class="card-body p-10 p-lg-20" v-else>
          <div class="text-center mb-11">
            <h1 class="text-dark fw-bolder mb-3" v-text="$t('로그인')" />
          </div>
          <div class="alert alert-info text-center mb-5" style="font-size: 0.9em;">
            {{ $t('기존 인증 방식이 구글 reCAPTCHA 방식으로 변경되었습니다. ') }}<br/>
            {{ $t('이제 아이디와 비밀번호만 입력하시면 됩니다.') }}
          </div>
          <div class="fv-row mb-5 fv-plugins-icon-container">
            <input maxlength="100" @keydown.enter="window.pw.focus()" type="text" v-model="form.userId"
              :placeholder="$t('아이디')" class="form-control bg-transparent">
          </div>
          <div class="fv-row mb-5 fv-plugins-icon-container">
            <input maxlength="100" id="pw" type="password" v-model="form.password" :placeholder="$t('비밀번호')"
              class="form-control bg-transparent">
          </div>
          <!--
          <div class="d-flex mb-3">
            <img class="form-control w-50 p-0" :src="capcha.capUrl" />
            <input ref="captchaInput" maxlength="100" @keydown.enter="login" v-model="capchaForm.chkCode" :placeholder="$t('인증번호')" class="ms-3 form-control bg-transparent">
          </div>
        -->
          <div class="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
           <!-- 
            <div>
              <a @click="playCapcha"><b-icon icon="volume-up-fill" /> {{ $t('음성듣기') }}</a>
              <a style="margin-left:1em" @click="getCapcha"><b-icon icon="arrow-counterclockwise" /> {{ $t('새로고침') }}</a>
            </div>
            -->
            <a @click="mode = 'findpw'" class="link-primary" v-text="$t('비밀번호 찾기')" />
          </div>
          <div class="d-grid mb-5">
            <button class="btn btn-primary" @click="login">
              <span v-if="mode == 'login'" class="indicator-label" v-text="$t('로그인')" />
              <span v-else class="d-block indicator-progress">
                {{ $t('로그인 처리중') }} ... <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </button>
          </div>
          <div class="text-gray-500 text-center fw-semibold fs-6">
            <a @click="mode = 'findid'" class="link-primary" v-text="$t('아이디 찾기')" />
          </div>
        </div>
        <div class="justify-between">
          <div class="text-left"><b-button v-b-modal.정보처리방침 size="sm" variant="light" class="d-inline me-8 btn-white-hov" style="background-color:white !important" v-text="$t('개인정보 처리방침')"/></div>
          <div class="text-right me-4" v-if="devMode">개발모드 <b-form-checkbox class="d-inline me-8" switch v-model="devMode" /></div>
        </div>
      </div>
    </div>
    <b-modal id="설명" modal-class="full" hide-footer :ok-title="$t('동의')" size="lg" :cancel-title="$t('취소')"
      :title="$t('서비스 이용 동의')" @show="setCheckAction" @ok="agree = true">
      <b-embed src="/assets/agree_en.html" allowfullscreen />
    </b-modal>
    
    <b-modal id="정보처리방침" ok-only :ok-title="$t('확인')" :title="$t('미즈호전자계약플랫폼(MeDP) 개인정보 처리방침')">
      <div class="scroll policy">
        <h5>제1조 총칙</h5>
        <div>
          <ul>
            <li>
              1. 개인정보란 생존하는 개인에 관한 정보로서 성명, 생년월일, 성별 등에 의하여 당해 개인을 알아볼 수 있는 부호, 문자, 음성, 음향, 영상 및 생체 특성 등에 관한 
                정보(당해 정보만으로는 특정 개인을 알아볼 수 없는 경우에도 다른 정보와 용이하게 결합하여 알아볼 수 있는 것을 포함)를 말합니다.
            </li>
            <li>
              2. 미즈호전자계약플랫폼, Mizuho electronic Document Platform(이하 MeDP)은 KT Paperless플랫폼을 기반으로 미즈호은행 디지털 전환을 위하여 개발된 서비스입니다. 
                MeDP는 고객님의 개인정보를 중요시하며, 「개인정보 보호법」과 개인정보 보호 관련 각종 법규를 준수하고 있습니다.
            </li>
            <li>
              3. MeDP는 개인정보처리방침을 통하여 고객님의 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.
            </li>
            <li>
              4. MeDP의 개인정보처리방침은 관련 법령 및 내부 운영 방침의 변경에 따라 개정될 수 있습니다. 개인정보처리방침이 개정되는 경우에는 시행일자 등을 부여하여 개정된 내용을 
                홈페이지(<a href="https://medp.mizuhobank.com">https://medp.mizuhobank.com</a>)에 지체 없이 공지합니다.
            </li>
            <li>
              5. 영업의 전부 또는 일부를 양도하거나 합병 등으로 개인정보를 이전하는 경우 서면 전자우편 등을 통하여 고객님께 개별적으로 통지하고, MeDP의 과실 없이 고객님의 
                연락처를 알 수 없는 경우에 해당하여 서면, 전자우편 등으로 통지할 수 없는 경우에는 홈페이지(https://medp.mizuhobank.com), 
                첫 화면에서 식별할 수 있도록 표기하여 30일 이상 그 사실을 공지합니다.
                <font color="#f73E56">
                단, 천재지변 등 정당한 사유로 홈페이지 게시가 곤란한 경우에는 2곳 이상의 중앙일간지(고객님의 대부분이 특정 지역에 거주하는 경우에는 
                그 지역을 보급구역으로 하는 일간지로 할 수 있습니다.)에 1회 이상 공고하는 것으로 갈음합니다.
                </font>
            </li>
          </ul>
        </div>

        <h5>제2조 개인정보의 수집∙이용 목적 및 항목</h5>
        <div>
          <ul>
            <li>
              1. MeDP는 회원가입, 상담, 서비스 제공 등을 위하여 필요한 범위에서 최소한의 개인정보만을 수집합니다.
            </li>
            <li>
              2. 사상, 신념, 가족 및 친인척관계, 학력(學歷)·병력(病歷), 기타 사회활동 경력 등 고객님의 권리 이익이나 사생활을 뚜렷하게 침해할 우려가 있는 개인정보는 수집하지 않습니다. 
              다만, 고객님께서 수집에 동의하시거나 다른 법률에 따라 특별히 수집 대상 개인정보로 허용된 경우에는 필요한 범위에서 최소한으로 위 개인정보를 수집할 수 있습니다.
            </li>
            <li>
              3. MeDP가 수집하는 개인정보 항목과 수집∙이용하는 목적은 다음과 같습니다.
              <h6>가. 필수 수집∙이용 목적 및 항목</h6>
              <div class="basic-table">
                <table>
                  <colgroup>
                    <col width="40%">
                    <col width="60%">
                  </colgroup>
                  <thead>
                    <tr>
                      <th>수집∙이용목적</th>
                      <th>항목</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        서비스 가입/변경/해지, 서비스 이용등록/AS처리, 본인확인, 개인식별, 가입의사확인, 고지사항전달, 
                        서비스제공관련 안내, 가입사실 통보, 서비스 품질개선, 서비스 이용 확인ㆍ점검
                      </td>
                      <td>
                        신청인 성명, 휴대폰 번호, 이메일주소, 아이디, 부서명, 직위
                      </td>
                    </tr>
                  </tbody>
                </table>
                ※ 위 정보는 가입 당시 정보뿐만 아니라 정보 수정으로 변경된 정보를 포함합니다.
              </div>
            </li>
            <li>
              4. MeDP는 아래의 경우에 한하여 고객님의 동의 없이 고객님의 개인정보를 수집∙이용할 수 있습니다.
            </li>
            <li>
              <ul class="s-list">
                <li>
                  가. 고객님과의 계약을 이행하기 위하여 필요한 개인정보로서 경제적∙기술적인 사유로 통상적인 동의를 받는 것이 뚜렷하게 곤란한 경우
                </li>
                <li>
                  나. 서비스의 제공에 따른 요금정산을 위하여 필요한 경우
                </li>
                <li>
                  다. 관련 법령에 특별한 규정이 있는 경우
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제3조 개인정보의 수집방법</h5>
        <div class="m-t">
          <ul>
            <li>
              MeDP는 다음과 같은 방법으로 개인정보를 수집합니다.
            </li>
            <li>
              <ul class="s-list">
                <li>
                  가. 고객사 대표자에게 가입신청서를 전자우편을 통한 수집
                </li>
                <li>
                  나. 가입신청서내 홈페이지 이용 대상 직원 리스트 포함
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제4조 개인정보의 보유 및 이용기간</h5>
        <div>
          <ul>
            <li>
              1. MeDP는 고객님의 개인정보를 고객님께 서비스를 제공하는 기간 또는 분쟁처리 기간 동안에 한하여 보유하고 이를 이용합니다.
              <ul class="s-list">
                <li>
                  가. 서비스 가입기간(가입일 ~ 해지일)
                </li>
                <li>
                  나. 요금정산, 요금 과오납 등 분쟁 대비를 위해 서비스 이용 후 6개월까지
                </li>
                <li>
                  다. 요금관련 분쟁 등 서비스 이용과 관련된 민원/분쟁이 계속될 경우에는 민원/분쟁 해결 시까지 보유(단, 관계 법령에 특별한 규정이 있을 경우 관련 법령에 따라 보관)
                </li>
              </ul>
            </li>
            <li>
              2. 상법, 국세기본법, 통신비밀보호법, 전자상거래 등에서의 소비자보호에 관한 법률, 신용정보의 이용 및 보호에 관한 법률 등 관계법령에 따라 보존할 필요가 있는 경우 
              회사는 관계법령에서 정한 기간 동안 고객의 개인정보를 보유하며, 그 기간은 다음과 같습니다.
            </li>
            <li>
              <div class="basic-table">
                <table>
                  <colgroup>
                    <col width="25%">
                    <col width="60%">
                    <col width="15%">
                  </colgroup>
                  <thead>
                    <tr>
                      <th>보존 근거</th>
                      <th>보존 대상</th>
                      <th>보존 기간</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th rowspan="2">상법</th>
                      <td>상업장부와 영업에 관한 중요서류에 포함된 개인정보</td>
                      <td style="text-align: center;">10년</td>
                    </tr>
                    <tr>
                      <td>전표 또는 이와 유사한 서류에 포함된 개인정보</td>
                      <td style="text-align: center;">5년</td>
                    </tr>
                    <tr>
                      <th>국세기본법</th>
                      <td>성명, 주민번호, 전화번호, 청구지 주소, 요금납부내역 등 거래에 관한 장부 및 증거서류</td>
                      <td style="text-align: center;">5년</td>
                    </tr>
                    <tr>
                      <th rowspan="2">통신비밀보호법</th>
                      <td>통신사실확인자료 제공에 필요한 성명, 주민번호, 전화번호 및 가입자의 전기통신일시, 전기통신개시ㆍ종료시간, 발ㆍ착신 통신번호 등 상대방의 가입자번호, 사용도수, 발신기지국의 위치정보</td>
                      <td style="text-align: center;">12개월<br />
                        <font style="font-size: 0.5rem !important;">단, 시외/시내전화 역무와 관련된 자료 : 6개월</font>
                      </td>
                    </tr>
                    <tr>
                      <td>컴퓨터통신 또는 인터넷의 로그기록자료, 정보통신기기의 위치를 확인할 수 있는 접속지의 추적자료</td>
                      <td style="text-align: center;">3개월</td>
                    </tr>
                    <tr>
                      <th rowspan="4">전자상거래 등에서의 <br>소비자보호에 관한 법률<br>
                      (전자상거래법)</th>
                      <td>계약 또는 청약철회 등에 관한 기록</td>
                      <td style="text-align: center;">5년</td>
                    </tr>
                    <tr>
                      <td>대금결제 및 재화 등의 <br>공급에 관한 기록</td>
                      <td style="text-align: center;">5년</td>
                    </tr>
                    <tr>
                      <td>소비자의 불만 또는 <br>분쟁처리에 관한 기록</td>
                      <td style="text-align: center;">3년</td>
                    </tr>
                    <tr>
                      <td>표시/광고에 관한 기록</td>
                      <td style="text-align: center;">6개월</td>
                    </tr>
                    <tr>
                      <th>신용정보의 이용 및 <br>보호에 관한 법률</th>
                      <td>신용정보의 수집/처리 및 이용 등에 관한 기록</td>
                      <td style="text-align: center;">3년</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
          </ul>
        </div>


        <h5>제5조 개인정보의 파기절차 및 방법</h5>
        <div class="m-t">
          <span>
            MeDP는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 파기절차 및 방법은 다음과 같습니다.
          </span>
          <ul>
            <li>
              1. 파기절차
              <ul class="s-list">
                <li>
                  가. 고객님의 개인정보는 수집 및 이용목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유(보유 및 이용기간 참조)에 따라 일정 기간 저장된 후 파기됩니다.
                </li>
                <li>
                  나. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우와 재가입시 가입비 면제 대상여부를 확인하는 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.
                </li>
              </ul>
            </li>
            <li>
              2. 파기방법
              <ul class="s-list">
                <li>
                  가. 종이(서면)에 작성·출력된 개인정보 : 분쇄하거나 소각 등의 방법으로 파기
                </li>
                <li>
                  나. DB 등 전자적 파일 형태로 저장된 개인정보 : 재생할 수 없는 기술적 방법으로 삭제
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제6조 수집한 개인정보의 공유 및 제공</h5>
        <div>
          <ul>
            <li>
              1. MeDP는 고객님의 사전 동의 없이 고객님의 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우는 예외로 합니다.
              <ul class="s-list">
                <li>가. 요금정산을 위하여 필요한 경우</li>
                <li>나. 관련 법령(통신비밀보호법, 전기통신사업법, 국세기본법 등)에 특별한 규정이 있는 경우로서, 법령에 정해진 규정과 절차에 따라 제공하는 경우</li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제7조 개인정보 처리의 위탁</h5>
        <div>
          MeDP는 서비스 제공에 관한 계약을 이행하고 고객님의 편의 증진 등을 위하여 개인정보 처리업무를 외부 전문업체에게 위탁하고 있으며, 
          수탁자에 대해서는 “위∙수탁계약서” 등을 통하여 관련 법규 및 지침의 준수, 정보보호 및 비밀유지, 제3자 제공 금지, 사고 시 책임부담, 
          위탁기간 종료 즉시 개인정보의 반납/파기 의무 등 책임에 관한 사항을 규정하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
          <ul>
            <li class="m-t">
              [개인정보 처리업무 수탁자 및 위탁 업무 내용]
              <div class="basic-table">
                <table class="center">
                  <colgroup>
                    <col width="34%">
                    <col width="34%">
                    <col>
                  </colgroup>
                  <thead>
                    <tr>
                      <th>수탁사</th>
                      <th>위탁 업무 내용</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>주식회사 케이원</td>
                      <td>전자계약(전자청약)/전자등기/전자문서보관 서비스 개발, 시스템 운영 A/S 등 유지보수</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
            <li>
              ※ 수탁사 리스트는 해당 서비스 변경 및 계약기간에 따라 변경될 수 있습니다.
            </li>
          </ul>
        </div>

        <h5>제8조 이용자 및 법정대리인의 권리와 그 행사 방법</h5>
        <div>
          <ul>
            <li>
              1. 고객님께서는 언제든지 개인정보, 개인정보를 이용하거나 제3자에게 제공한 현황, 개인정보 수집∙이용∙제공 등의 동의를 한 현황(이하 ‘개인정보 등’이라 합니다)에 대한 열람이나 제공을 요구하실 수 있고, 오류가 있는 경우에는 그 정정을 요구하실 수 있으며, 개인정보의 수집∙이용∙제공에 대한 동의를 철회를 하실 수 있습니다.
            </li>
            <li>
              2. 고객님의 개인정보 등에 대한 열람 및 정정을 위해서는 고객님(법정대리인)께서 회사를 직접 방문하시거나 고객센터로 전화 문의 또는 홈페이지 내 ‘정보수정’을 클릭하여 직접 열람 및 정정(선택적 동의철회 포함)을 하실 수 있습니다.
            </li>
            <li>
              3. 고객님께서 본인의 개인정보 등에 대한 열람이나 정정을 요구하시거나 개인정보 수집∙이용∙제공 등의 동의를 철회하시는 경우 고객님의 신분을 증명할 수 있는 주민등록증, 여권, 운전면허증(신형) 등의 신분증명(사본)을 제시 받아 본인 여부를 확인합니다.
            </li>
            <li>
              4. 고객님의 대리인이 고객님의 개인정보 등에 대한 열람이나 정정을 요구하거나 고객님의 개인정보의 수집∙이용∙제공에 대한 동의를 철회하는 경우에는 대리 관계를 나타내는 위임장, 명의고객님의 인감증명서와 대리인의 신분증명서 등의 증표를 제시 받아 적법한 대리인인지 여부를 확인합니다.
            </li>
            <li>
              5. 고객님께서는 개인정보 등의 열람이나 제공을 요청하실 수 있으며, MeDP는 이러한 요청에 지체 없이 필요한 조치를 취합니다.
            </li>
            <li>
              6. 고객님께서 개인정보 등의 오류에 대한 정정을 요청하신 경우에는 지체 없이 그 오류를 정정하거나 정정하지 못하는 사유를 이용자에게 알리는 등 필요한 조치를 하고, 필요한 조치를 할 때까지는 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다. 다만, 다른 법률에 따라 개인정보의 제공을 요청 받은 경우에는 그 개인정보를 제공하거나 이용할 수 있습니다.
            </li>
            <li>
              7. MeDP는 고객님의 요청에 의해 해지 또는 삭제된 개인정보를 “개인정보의 보유 및 이용기간”에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.
            </li>
          </ul>
        </div>

        <h5>제9조 개인정보 자동 수집장치의 설치 운영 및 그 거부에 관한 사항</h5>
        <div>
          MeDP는 홈페이지 운영에 있어 필요 시 고객님의 정보를 찾아내고 저장하는 &#39;쿠키(Cookie)&#39;를
          운용합니다. 쿠키는 MeDP의 웹사이트를 운영하는데 이용되는 서버가 고객님의 브라우저에 보내는
          아주 작은 텍스트 파일로서 고객님의 컴퓨터 하드디스크에 저장됩니다. 고객님께서는 웹브라우저의
          보안 정책을 통해 쿠키에 의한 정보수집의 허용 거부 여부를 결정하실 수 있습니다.
          <ul>
            <li>
              1. 쿠키에 의해 수집되는 정보 및 이용 목적 
            </li>
            <li>
              <ul class="s-list">
                <li>
                  가. 수집 정보 : 고유한 사용자를 식별하기 위해 무작위로 생성된 숫자 세트와 타임스탬프
                </li>
                <li>
                  나. 이용목적 : 회원의 접속빈도나 방문시간 등의 분석을 통해 서비스 이용률 및 관심도를 파악하여 서비스 개편 등의 척도로 활용
                </li>
              </ul>
            </li>
            <li>
              2. 고객님은 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 웹브라우저에서 옵션을 설정함으로써 쿠키에 의한 정보 수집 수준의 선택을 조정하실 수 있습니다.
            </li>
            <li>
              <ul class="s-list">
                <li>
                  가. 웹브라우저의 [도구]메뉴[인터넷옵션][개인정보]에서 쿠키에 의한 정보 수집 수준을 정할 수 있습니다.
                </li>
                <li>
                  나. 위에 제시된 메뉴를 통해 쿠키가 저장될 때마다 확인을 하거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다. 단, 고객님께서 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.
                </li>
              </ul>
            </li>
          </ul>
        </div>


        <h5>제10조 개인정보의 기술적, 관리적 보호</h5>
        <div>
          MeDP는 고객님의 개인정보가 분실, 도난, 유출, 위조∙변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적∙관리적 대책을 마련하고 있습니다.
          <ul class="m-t">
            [기술적 보호대책]
            <li>
              1. 고객님의 개인정보를 암호화하여 저장하며, 정보통신망을 통해 고객님의 개인정보 및 인증정보를 송∙수신 하는 경우에는 안전한 보안서버 구축 등의 조치를 통해 암호화 하여 보호하고 있습니다.
            </li>
            <li>
              2. 백신 소프트웨어를 이용하여 컴퓨터바이러스 등에 의한 피해를 방지하기 위한 조치를 취하고 있습니다. 백신 소프트웨어는 주기적으로 업데이트되며 갑작스런 바이러스가 출현할 경우 백신이 나오는 즉시 이를 도입, 적용함으로써 개인정보가 침해되는 것을 방지하고 있습니다.
            </li>
            <li>
              3. 고객님의 개인정보에 대한 불법적인 접근을 차단하기 위해, 외부로부터 접근이 통제된 구역에 시스템을 설치하고, 침입을 차단하는 장치를 이용하고 있으며, 아울러 침입탐지시스템을 설치하여 24시간 침입을 감시하고 있습니다.
            </li>
          </ul>
          <ul class="m-t">
            [관리적 보호대책]
            <li>
              1. MeDP는 고객님의 개인정보를 안전하게 처리하기 위한 내부관리계획을 마련하여 소속 직원이 이를 숙지하고 준수하도록 하고 있습니다.
            </li>
            <li>
              2. MeDP는 고객님의 개인정보를 처리할 수 있는 자를 최소한으로 제한하고 접근 권한을 관리하며, 새로운 보안 기술 습득 및 개인정보보호 의무 등에 관해 정기적인 사내 교육과 외부 위탁교육을 통하여 법규 및 정책을 준수할 수 있도록 하고 있습니다. 고객님의 개인정보를 처리하는 자는 다음과 같습니다.
              <ul class="s-list">
                <li>가. 고객님을 직·간접적으로 상대하여 마케팅 업무를 수행하는 자</li>
                <li>나. 개인정보 보호책임자 및 개인정보 보호담당자 등 개인정보 관리 및 개인정보보호 업무를 담당하는 자</li>
                <li>다. 기타 업무상 개인정보의 처리가 불가피한 자</li>
              </ul>
            </li>
            <li>
              3. 전 임직원이 정보보호서약서에 서명하게 함으로써 직원에 의한 정보(개인정보 포함)유출을 사전에 방지하고, 수시로 개인정보보호 의무를 상기시키며 준수 여부를 감사하기 위한 내부 절차를 마련하여 시행하고 있습니다.
            </li>
            <li>
              4. 개인정보취급자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이루어지도록 하여, 입사 및 퇴사 후 개인정보 침해사고에 대한 책임을 명확하게 규정하고 있습니다.4. 개인정보취급자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이루어지도록 하여, 입사 및 퇴사 후 개인정보 침해사고에 대한 책임을 명확하게 규정하고 있습니다.
            </li>
            <li>
              5. 전산실 및 자료보관실 등을 통제구역으로 설정하여 출입을 통제합니다.
            </li>
            <li>
              6. MeDP는 고객님 개인의 실수나 기본적인 인터넷의 위험성 때문에 일어나는 일들에 대해 책임을 지지 않습니다. 고객님의 개인정보를 보호하기 위해서 자신의 ID와 비밀번호를 철저히 관리하고 책임을 져야 합니다.
            </li>
          </ul>
        </div>

        <h5>제11조 개인정보 보호책임 부서 및 연락처</h5>
        <div>
          <ul class="m-t">
            <li>
              1. 케이티는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
            </li>
            <li>
              2. 정보주체는 개인정보보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 케이티 개인정보 보호책임자 또는 MeDP서비스 개인정보보호 담당자에게 문의할 수 있습니다.
            </li>
            <li>
              3. 정보주체는 「개인정보 보호법」 제35조에 따른 개인정보의 열람 청구를 MeDP서비스 개인정보 보호 담당부서에 할 수 있습니다.
            </li>
            <li class="m-t">
              [케이티 개인정보 보호책임자]
              <div class="basic-table">
                <table class="center">
                  <colgroup>
                    <col width="34%">
                    <col width="20%">
                    <col>
                  </colgroup>
                  <thead>
                    <tr>
                      <th>구분</th>
                      <th>성명</th>
                      <th>연락처</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>개인정보 보호책임자(CPO)</td>
                      <td>김창오</td>
                      <td>이메일 : privacy@kt.com</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
            <li class="m-t">
              [MeDP 개인정보보호 담당자]
              <div class="basic-table">
                <table class="center">
                  <colgroup>
                    <col width="34%">
                    <col width="20%">
                    <col>
                  </colgroup>
                  <thead>
                    <tr>
                      <th>구분</th>
                      <th>성명</th>
                      <th>연락처</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>개인정보보호 담당자</td>
                      <td>이국화</td>
                      <td>전화번호 : 080-318-5306<br>이메일 : kukhwa.lee@kt.com</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
          </ul>
        </div>

        <h5>제12조 개인정보 열람청구</h5>
        <div>
          <ul class="m-t">
            <li>
              [MeDP 개인정보보호 열람청구 접수∙처리 부서]
              <div class="basic-table">
                <table class="center">
                  <colgroup>
                    <col width="34%">
                    <col width="20%">
                    <col>
                  </colgroup>
                  <thead>
                    <tr>
                      <th>구분</th>
                      <th>성명</th>
                      <th>연락처</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>개인정보 열람청구 접수·처리 담당자</td>
                      <td>신현호</td>
                      <td>전화번호 : 080-318-5306<br>이메일 : hyunho.shin@kt.com</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
          </ul>
        </div>

        <h5>제13조 권익침해 구제방법</h5>
        <div>
          기타 개인정보 침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하여 주시기 바랍니다.
          <ul class="m-t">
            <li>
              1. 개인정보 침해신고센터 (한국인터넷진흥원 운영)
              <ul>
                <li>가. 소관업무 : 개인정보 침해사실 신고, 상담 신청</li>
                <li>나. 홈페이지/전화 : http://privacy.kisa.or.kr / (국번없이) 118</li>
              </ul>
            </li>
            <li>
              2. 개인정보 분쟁조정위원회
              <ul>
                <li>가. 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)</li>
                <li>나. 홈페이지/전화 : www.kopico.go.kr / (국번없이) 1833-6972</li>
              </ul>
            </li>
            <li>3. 대검찰청 사이버수사과 : www.spo.go.kr / (국번없이) 1301</li>
            <li>4. 경찰청 사이버안전국 : https://ecrm.police.go.kr / (국번없이) 182</li>
          </ul>
        </div>

        <h5>제14조 개인정보처리방침 고지</h5>
        <div>
          <ul>
            <li>
              1. KT MeDP 개인정보처리방침 공고/시행일자
              <ul class="s-list">
                <li>가. 공고일자 : [2026/08/25]</li>
                <li>나. 시행일자 : [2026/09/01]</li>
              </ul>
            </li>
            <li>
              2. 이전 개인정보처리방침은 아래에서 확인하실 수 있습니다.
              <ul class="s-list">
                <li>
                  가. <b-link v-b-modal.이전정보처리방침_2023 style="text-decoration: underline;">2023.06.01~2023.06.30 적용</b-link> (클릭)
                </li>
                <li>
                  나. <b-link v-b-modal.이전정보처리방침 style="text-decoration: underline;">2023.07.01~2026.06.30 적용</b-link> (클릭)
                </li>
                <li>
                  다. <b-link v-b-modal.이전정보처리방침2 style="text-decoration: underline;">2026.07.01~2026.08.31 적용</b-link> (클릭)
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>

    <b-modal id="이전정보처리방침2" ok-only :ok-title="$t('확인')" :title="$t('미즈호전자계약플랫폼(MeDP) 개인정보 처리방침')">
      <div class="scroll policy">
        <h5>제1조 총칙</h5>
        <div>
          <ul>
            <li>
              1. 개인정보란 생존하는 개인에 관한 정보로서 성명, 생년월일, 성별 등에 의하여 당해 개인을 알아볼 수 있는 부호, 문자, 음성, 음향, 영상 및 생체 특성 등에 관한 
                정보(당해 정보만으로는 특정 개인을 알아볼 수 없는 경우에도 다른 정보와 용이하게 결합하여 알아볼 수 있는 것을 포함)를 말합니다.
            </li>
            <li>
              2. 미즈호전자계약플랫폼, Mizuho electronic Document Platform(이하 MeDP)은 KT Paperless플랫폼을 기반으로 미즈호은행 디지털 전환을 위하여 개발된 서비스입니다. 
                MeDP는 고객님의 개인정보를 중요시하며, 「개인정보 보호법」과 개인정보 보호 관련 각종 법규를 준수하고 있습니다.
            </li>
            <li>
              3. MeDP는 개인정보처리방침을 통하여 고객님의 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.
            </li>
            <li>
              4. MeDP의 개인정보처리방침은 관련 법령 및 내부 운영 방침의 변경에 따라 개정될 수 있습니다. 개인정보처리방침이 개정되는 경우에는 시행일자 등을 부여하여 개정된 내용을 
                홈페이지(<a href="https://medp.mizuhobank.com">https://medp.mizuhobank.com</a>)에 지체 없이 공지합니다.
            </li>
            <li>
              5. 영업의 전부 또는 일부를 양도하거나 합병 등으로 개인정보를 이전하는 경우 서면 전자우편 등을 통하여 고객님께 개별적으로 통지하고, MeDP의 과실 없이 고객님의 
                연락처를 알 수 없는 경우에 해당하여 서면, 전자우편 등으로 통지할 수 없는 경우에는 홈페이지(https://medp.mizuhobank.com), 
                첫 화면에서 식별할 수 있도록 표기하여 30일 이상 그 사실을 공지합니다.
                <font color="#f73E56">
                단, 천재지변 등 정당한 사유로 홈페이지 게시가 곤란한 경우에는 2곳 이상의 중앙일간지(고객님의 대부분이 특정 지역에 거주하는 경우에는 
                그 지역을 보급구역으로 하는 일간지로 할 수 있습니다.)에 1회 이상 공고하는 것으로 갈음합니다.
                </font>
            </li>
          </ul>
        </div>

        <h5>제2조 개인정보의 수집∙이용 목적 및 항목</h5>
        <div>
          <ul>
            <li>
              1. MeDP는 회원가입, 상담, 서비스 제공 등을 위하여 필요한 범위에서 최소한의 개인정보만을 수집합니다.
            </li>
            <li>
              2. 사상, 신념, 가족 및 친인척관계, 학력(學歷)·병력(病歷), 기타 사회활동 경력 등 고객님의 권리 이익이나 사생활을 뚜렷하게 침해할 우려가 있는 개인정보는 수집하지 않습니다. 
              다만, 고객님께서 수집에 동의하시거나 다른 법률에 따라 특별히 수집 대상 개인정보로 허용된 경우에는 필요한 범위에서 최소한으로 위 개인정보를 수집할 수 있습니다.
            </li>
            <li>
              3. MeDP가 수집하는 개인정보 항목과 수집∙이용하는 목적은 다음과 같습니다.
              <h6>가. 필수 수집∙이용 목적 및 항목</h6>
              <div class="basic-table">
                <table>
                  <colgroup>
                    <col width="40%">
                    <col width="60%">
                  </colgroup>
                  <thead>
                    <tr>
                      <th>수집∙이용목적</th>
                      <th>항목</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        서비스 가입/변경/해지, 서비스 이용등록/AS처리, 본인확인, 개인식별, 가입의사확인, 고지사항전달, 
                        서비스제공관련 안내, 가입사실 통보, 서비스 품질개선, 서비스 이용 확인ㆍ점검
                      </td>
                      <td>
                        신청인 성명, 휴대폰 번호, 이메일주소, 아이디, 부서명, 직위
                      </td>
                    </tr>
                  </tbody>
                </table>
                ※ 위 정보는 가입 당시 정보뿐만 아니라 정보 수정으로 변경된 정보를 포함합니다.
              </div>
            </li>
            <li>
              4. MeDP는 아래의 경우에 한하여 고객님의 동의 없이 고객님의 개인정보를 수집∙이용할 수 있습니다.
            </li>
            <li>
              <ul class="s-list">
                <li>
                  가. 고객님과의 계약을 이행하기 위하여 필요한 개인정보로서 경제적∙기술적인 사유로 통상적인 동의를 받는 것이 뚜렷하게 곤란한 경우
                </li>
                <li>
                  나. 서비스의 제공에 따른 요금정산을 위하여 필요한 경우
                </li>
                <li>
                  다. 관련 법령에 특별한 규정이 있는 경우
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제3조 개인정보의 수집방법</h5>
        <div class="m-t">
          <ul>
            <li>
              MeDP는 다음과 같은 방법으로 개인정보를 수집합니다.
            </li>
            <li>
              <ul class="s-list">
                <li>
                  가. 고객사 대표자에게 가입신청서를 전자우편을 통한 수집
                </li>
                <li>
                  나. 가입신청서내 홈페이지 이용 대상 직원 리스트 포함
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제4조 개인정보의 보유 및 이용기간</h5>
        <div>
          <ul>
            <li>
              1. MeDP는 고객님의 개인정보를 고객님께 서비스를 제공하는 기간 또는 분쟁처리 기간 동안에 한하여 보유하고 이를 이용합니다.
              <ul class="s-list">
                <li>
                  가. 서비스 가입기간(가입일 ~ 해지일)
                </li>
                <li>
                  나. 요금정산, 요금 과오납 등 분쟁 대비를 위해 서비스 이용 후 6개월까지
                </li>
                <li>
                  다. 요금관련 분쟁 등 서비스 이용과 관련된 민원/분쟁이 계속될 경우에는 민원/분쟁 해결 시까지 보유(단, 관계 법령에 특별한 규정이 있을 경우 관련 법령에 따라 보관)
                </li>
              </ul>
            </li>
            <li>
              2. 상법, 국세기본법, 통신비밀보호법, 전자상거래 등에서의 소비자보호에 관한 법률, 신용정보의 이용 및 보호에 관한 법률 등 관계법령에 따라 보존할 필요가 있는 경우 
              회사는 관계법령에서 정한 기간 동안 고객의 개인정보를 보유하며, 그 기간은 다음과 같습니다.
            </li>
            <li>
              <div class="basic-table">
                <table>
                  <colgroup>
                    <col width="25%">
                    <col width="60%">
                    <col width="15%">
                  </colgroup>
                  <thead>
                    <tr>
                      <th>보존 근거</th>
                      <th>보존 대상</th>
                      <th>보존 기간</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th rowspan="2">상법</th>
                      <td>상업장부와 영업에 관한 중요서류에 포함된 개인정보</td>
                      <td style="text-align: center;">10년</td>
                    </tr>
                    <tr>
                      <td>전표 또는 이와 유사한 서류에 포함된 개인정보</td>
                      <td style="text-align: center;">5년</td>
                    </tr>
                    <tr>
                      <th>국세기본법</th>
                      <td>성명, 주민번호, 전화번호, 청구지 주소, 요금납부내역 등 거래에 관한 장부 및 증거서류</td>
                      <td style="text-align: center;">5년</td>
                    </tr>
                    <tr>
                      <th rowspan="2">통신비밀보호법</th>
                      <td>통신사실확인자료 제공에 필요한 성명, 주민번호, 전화번호 및 가입자의 전기통신일시, 전기통신개시ㆍ종료시간, 발ㆍ착신 통신번호 등 상대방의 가입자번호, 사용도수, 발신기지국의 위치정보</td>
                      <td style="text-align: center;">12개월<br />
                        <font style="font-size: 0.5rem !important;">단, 시외/시내전화 역무와 관련된 자료 : 6개월</font>
                      </td>
                    </tr>
                    <tr>
                      <td>컴퓨터통신 또는 인터넷의 로그기록자료, 정보통신기기의 위치를 확인할 수 있는 접속지의 추적자료</td>
                      <td style="text-align: center;">3개월</td>
                    </tr>
                    <tr>
                      <th rowspan="4">전자상거래 등에서의 <br>소비자보호에 관한 법률<br>
                      (전자상거래법)</th>
                      <td>계약 또는 청약철회 등에 관한 기록</td>
                      <td style="text-align: center;">5년</td>
                    </tr>
                    <tr>
                      <td>대금결제 및 재화 등의 <br>공급에 관한 기록</td>
                      <td style="text-align: center;">5년</td>
                    </tr>
                    <tr>
                      <td>소비자의 불만 또는 <br>분쟁처리에 관한 기록</td>
                      <td style="text-align: center;">3년</td>
                    </tr>
                    <tr>
                      <td>표시/광고에 관한 기록</td>
                      <td style="text-align: center;">6개월</td>
                    </tr>
                    <tr>
                      <th>신용정보의 이용 및 <br>보호에 관한 법률</th>
                      <td>신용정보의 수집/처리 및 이용 등에 관한 기록</td>
                      <td style="text-align: center;">3년</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
          </ul>
        </div>


        <h5>제5조 개인정보의 파기절차 및 방법</h5>
        <div class="m-t">
          <span>
            MeDP는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 파기절차 및 방법은 다음과 같습니다.
          </span>
          <ul>
            <li>
              1. 파기절차
              <ul class="s-list">
                <li>
                  가. 고객님의 개인정보는 수집 및 이용목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유(보유 및 이용기간 참조)에 따라 일정 기간 저장된 후 파기됩니다.
                </li>
                <li>
                  나. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우와 재가입시 가입비 면제 대상여부를 확인하는 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.
                </li>
              </ul>
            </li>
            <li>
              2. 파기방법
              <ul class="s-list">
                <li>
                  가. 종이(서면)에 작성·출력된 개인정보 : 분쇄하거나 소각 등의 방법으로 파기
                </li>
                <li>
                  나. DB 등 전자적 파일 형태로 저장된 개인정보 : 재생할 수 없는 기술적 방법으로 삭제
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제6조 수집한 개인정보의 공유 및 제공</h5>
        <div>
          <ul>
            <li>
              1. MeDP는 고객님의 사전 동의 없이 고객님의 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우는 예외로 합니다.
              <ul class="s-list">
                <li>가. 요금정산을 위하여 필요한 경우</li>
                <li>나. 관련 법령(통신비밀보호법, 전기통신사업법, 국세기본법 등)에 특별한 규정이 있는 경우로서, 법령에 정해진 규정과 절차에 따라 제공하는 경우</li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제7조 개인정보 처리의 위탁</h5>
        <div>
          MeDP는 서비스 제공에 관한 계약을 이행하고 고객님의 편의 증진 등을 위하여 개인정보 처리업무를 외부 전문업체에게 위탁하고 있으며, 
          수탁자에 대해서는 “위∙수탁계약서” 등을 통하여 관련 법규 및 지침의 준수, 정보보호 및 비밀유지, 제3자 제공 금지, 사고 시 책임부담, 
          위탁기간 종료 즉시 개인정보의 반납/파기 의무 등 책임에 관한 사항을 규정하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
          <ul>
            <li class="m-t">
              [개인정보 처리업무 수탁자 및 위탁 업무 내용]
              <div class="basic-table">
                <table class="center">
                  <colgroup>
                    <col width="34%">
                    <col width="34%">
                    <col>
                  </colgroup>
                  <thead>
                    <tr>
                      <th>수탁사</th>
                      <th>위탁 업무 내용</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>주식회사 케이원</td>
                      <td>전자계약(전자청약)/전자등기/전자문서보관 서비스 개발, 시스템 운영 A/S 등 유지보수</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
            <li>
              ※ 수탁사 리스트는 해당 서비스 변경 및 계약기간에 따라 변경될 수 있습니다.
            </li>
          </ul>
        </div>

        <h5>제8조 이용자 및 법정대리인의 권리와 그 행사 방법</h5>
        <div>
          <ul>
            <li>
              1. 고객님께서는 언제든지 개인정보, 개인정보를 이용하거나 제3자에게 제공한 현황, 개인정보 수집∙이용∙제공 등의 동의를 한 현황(이하 ‘개인정보 등’이라 합니다)에 대한 열람이나 제공을 요구하실 수 있고, 오류가 있는 경우에는 그 정정을 요구하실 수 있으며, 개인정보의 수집∙이용∙제공에 대한 동의를 철회를 하실 수 있습니다.
            </li>
            <li>
              2. 고객님의 개인정보 등에 대한 열람 및 정정을 위해서는 고객님(법정대리인)께서 회사를 직접 방문하시거나 고객센터로 전화 문의 또는 홈페이지 내 ‘정보수정’을 클릭하여 직접 열람 및 정정(선택적 동의철회 포함)을 하실 수 있습니다.
            </li>
            <li>
              3. 고객님께서 본인의 개인정보 등에 대한 열람이나 정정을 요구하시거나 개인정보 수집∙이용∙제공 등의 동의를 철회하시는 경우 고객님의 신분을 증명할 수 있는 주민등록증, 여권, 운전면허증(신형) 등의 신분증명(사본)을 제시 받아 본인 여부를 확인합니다.
            </li>
            <li>
              4. 고객님의 대리인이 고객님의 개인정보 등에 대한 열람이나 정정을 요구하거나 고객님의 개인정보의 수집∙이용∙제공에 대한 동의를 철회하는 경우에는 대리 관계를 나타내는 위임장, 명의고객님의 인감증명서와 대리인의 신분증명서 등의 증표를 제시 받아 적법한 대리인인지 여부를 확인합니다.
            </li>
            <li>
              5. 고객님께서는 개인정보 등의 열람이나 제공을 요청하실 수 있으며, MeDP는 이러한 요청에 지체 없이 필요한 조치를 취합니다.
            </li>
            <li>
              6. 고객님께서 개인정보 등의 오류에 대한 정정을 요청하신 경우에는 지체 없이 그 오류를 정정하거나 정정하지 못하는 사유를 이용자에게 알리는 등 필요한 조치를 하고, 필요한 조치를 할 때까지는 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다. 다만, 다른 법률에 따라 개인정보의 제공을 요청 받은 경우에는 그 개인정보를 제공하거나 이용할 수 있습니다.
            </li>
            <li>
              7. MeDP는 고객님의 요청에 의해 해지 또는 삭제된 개인정보를 “개인정보의 보유 및 이용기간”에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.
            </li>
          </ul>
        </div>

        <h5>제9조 개인정보 자동 수집장치의 설치 운영 및 그 거부에 관한 사항</h5>
        <div>
          MeDP는 홈페이지 운영에 있어 필요 시 고객님의 정보를 찾아내고 저장하는 &#39;쿠키(Cookie)&#39;를
          운용합니다. 쿠키는 MeDP의 웹사이트를 운영하는데 이용되는 서버가 고객님의 브라우저에 보내는
          아주 작은 텍스트 파일로서 고객님의 컴퓨터 하드디스크에 저장됩니다. 고객님께서는 웹브라우저의
          보안 정책을 통해 쿠키에 의한 정보수집의 허용 거부 여부를 결정하실 수 있습니다.
          <ul>
            <li>
              1. 쿠키에 의해 수집되는 정보 및 이용 목적 
            </li>
            <li>
              <ul class="s-list">
                <li>
                  가. 수집 정보 : 고유한 사용자를 식별하기 위해 무작위로 생성된 숫자 세트와 타임스탬프
                </li>
                <li>
                  나. 이용목적 : 회원의 접속빈도나 방문시간 등의 분석을 통해 서비스 이용률 및 관심도를 파악하여 서비스 개편 등의 척도로 활용
                </li>
              </ul>
            </li>
            <li>
              2. 고객님은 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 웹브라우저에서 옵션을 설정함으로써 쿠키에 의한 정보 수집 수준의 선택을 조정하실 수 있습니다.
            </li>
            <li>
              <ul class="s-list">
                <li>
                  가. 웹브라우저의 [도구]메뉴[인터넷옵션][개인정보]에서 쿠키에 의한 정보 수집 수준을 정할 수 있습니다.
                </li>
                <li>
                  나. 위에 제시된 메뉴를 통해 쿠키가 저장될 때마다 확인을 하거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다. 단, 고객님께서 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.
                </li>
              </ul>
            </li>
          </ul>
        </div>


        <h5>제10조 개인정보의 기술적, 관리적 보호</h5>
        <div>
          MeDP는 고객님의 개인정보가 분실, 도난, 유출, 위조∙변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적∙관리적 대책을 마련하고 있습니다.
          <ul class="m-t">
            [기술적 보호대책]
            <li>
              1. 고객님의 개인정보를 암호화하여 저장하며, 정보통신망을 통해 고객님의 개인정보 및 인증정보를 송∙수신 하는 경우에는 안전한 보안서버 구축 등의 조치를 통해 암호화 하여 보호하고 있습니다.
            </li>
            <li>
              2. 백신 소프트웨어를 이용하여 컴퓨터바이러스 등에 의한 피해를 방지하기 위한 조치를 취하고 있습니다. 백신 소프트웨어는 주기적으로 업데이트되며 갑작스런 바이러스가 출현할 경우 백신이 나오는 즉시 이를 도입, 적용함으로써 개인정보가 침해되는 것을 방지하고 있습니다.
            </li>
            <li>
              3. 고객님의 개인정보에 대한 불법적인 접근을 차단하기 위해, 외부로부터 접근이 통제된 구역에 시스템을 설치하고, 침입을 차단하는 장치를 이용하고 있으며, 아울러 침입탐지시스템을 설치하여 24시간 침입을 감시하고 있습니다.
            </li>
          </ul>
          <ul class="m-t">
            [관리적 보호대책]
            <li>
              1. MeDP는 고객님의 개인정보를 안전하게 처리하기 위한 내부관리계획을 마련하여 소속 직원이 이를 숙지하고 준수하도록 하고 있습니다.
            </li>
            <li>
              2. MeDP는 고객님의 개인정보를 처리할 수 있는 자를 최소한으로 제한하고 접근 권한을 관리하며, 새로운 보안 기술 습득 및 개인정보보호 의무 등에 관해 정기적인 사내 교육과 외부 위탁교육을 통하여 법규 및 정책을 준수할 수 있도록 하고 있습니다. 고객님의 개인정보를 처리하는 자는 다음과 같습니다.
              <ul class="s-list">
                <li>가. 고객님을 직·간접적으로 상대하여 마케팅 업무를 수행하는 자</li>
                <li>나. 개인정보 보호책임자 및 개인정보 보호담당자 등 개인정보 관리 및 개인정보보호 업무를 담당하는 자</li>
                <li>다. 기타 업무상 개인정보의 처리가 불가피한 자</li>
              </ul>
            </li>
            <li>
              3. 전 임직원이 정보보호서약서에 서명하게 함으로써 직원에 의한 정보(개인정보 포함)유출을 사전에 방지하고, 수시로 개인정보보호 의무를 상기시키며 준수 여부를 감사하기 위한 내부 절차를 마련하여 시행하고 있습니다.
            </li>
            <li>
              4. 개인정보취급자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이루어지도록 하여, 입사 및 퇴사 후 개인정보 침해사고에 대한 책임을 명확하게 규정하고 있습니다.4. 개인정보취급자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이루어지도록 하여, 입사 및 퇴사 후 개인정보 침해사고에 대한 책임을 명확하게 규정하고 있습니다.
            </li>
            <li>
              5. 전산실 및 자료보관실 등을 통제구역으로 설정하여 출입을 통제합니다.
            </li>
            <li>
              6. MeDP는 고객님 개인의 실수나 기본적인 인터넷의 위험성 때문에 일어나는 일들에 대해 책임을 지지 않습니다. 고객님의 개인정보를 보호하기 위해서 자신의 ID와 비밀번호를 철저히 관리하고 책임을 져야 합니다.
            </li>
          </ul>
        </div>

        <h5>제11조 개인정보 보호책임 부서 및 연락처</h5>
        <div>
          MeDP는 고객님의 개인정보를 보호하고 개인정보와 관련한 불만 및 문의사항을 처리하기 위하여 아래와 같이 관련 부서를 지정하여 운영하고 있습니다. 또한 고객님의 의견을 매우 소중하게 생각합니다. 고객님께서 MeDP서비스의 개인정보 관련 문의사항이 있을 경우 아래 개인정보 보호책임자 및 담당자에게 문의하시면 신속하고 성실하게 답변을 드리겠습니다.
          <ul class="m-t">
            <li>
              1. 개인정보 책임 부서 및 연락처
              <ul class="s-list">
                <li>
                  가. MeDP 개인정보 보호책임자 : 커뮤니케이션서비스 담당 RCS플랫폼서비스팀 이국화
                  <div class="m-l">
                    ㅇ 전화번호 : 080-318-5306<br>
                    ㅇ 이메일 : kukhwa.lee@kt.com
                  </div>
                </li>
                <li>
                  나. MeDP 개인정보 담당자 : 커뮤니케이션서비스 담당 RCS플랫폼서비스팀 신현호
                  <div class="m-l">
                    ㅇ 전화번호 : 080-318-5306<br>
                    ㅇ 이메일 : hyunho.shin@kt.com
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제12조 개인정보 열람청구</h5>
        <div>
          MeDP는 고객님의 개인정보 열람 청구를 위하여 아래와 같이 관련 부서를 지정하여 운영하고 있습니다.
          고객님께서 MeDP서비스에 개인정보 열람을 청구하실 경우 아래 부서 담당자에게 문의하시면 신속하고 성실하게 답변 드리겠습니다.
          <ul class="m-t">
            <li>
              [MeDP 개인정보 열람청구 접수∙처리 부서]
              <ul class="s-list">
                <li class="m-l">
                  가. 부서명 : 커뮤니케이션서비스 담당 RCS플랫폼서비스팀
                </li>
                <li class="m-l">
                  나. 담당자 : 신현호
                </li>
                <li class="m-l">
                  다. 연락처 : 080-318-5306, hyunho.shin@kt.com
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제13조 권익침해 구제방법</h5>
        <div>
          기타 개인정보 침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하여 주시기 바랍니다.
          <ul class="m-t">
            <li>
              1. 개인정보 침해신고센터 (한국인터넷진흥원 운영)
              <ul>
                <li>가. 소관업무 : 개인정보 침해사실 신고, 상담 신청</li>
                <li>나. 홈페이지/전화 : http://privacy.kisa.or.kr / (국번없이) 118</li>
              </ul>
            </li>
            <li>
              2. 개인정보 분쟁조정위원회
              <ul>
                <li>가. 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)</li>
                <li>나. 홈페이지/전화 : www.kopico.go.kr / (국번없이) 1833-6972</li>
              </ul>
            </li>
            <li>3. 대검찰청 사이버수사과 : www.spo.go.kr / (국번없이) 1301</li>
            <li>4. 경찰청 사이버안전국 : https://ecrm.police.go.kr / (국번없이) 182</li>
          </ul>
        </div>

        <h5>제14조 개인정보처리방침 고지</h5>
        <div>
          <ul>
            <li>
              1. KT MeDP 개인정보처리방침 공고/시행일자
              <ul class="s-list">
                <li>가. 공고일자 : [2026/06/25]</li>
                <li>나. 시행일자 : [2026/07/01]</li>
              </ul>
            </li>            
          </ul>
        </div>
      </div>
    </b-modal>
    <!-- 이전 개인정보 처리방침 -->
    <b-modal id="이전정보처리방침" ok-only :ok-title="$t('확인')" :title="$t('개인정보 처리방침')">
      <div class="scroll policy">
        <h5>제1조 총칙</h5>
        <div>
          <ul>
            <li>
              1. 개인정보란 생존하는 개인에 관한 정보로서 성명, 생년월일, 성별 등에 의하여 당해 개인을 알아볼 수 있는 부호, 문자, 음성, 음향, 영상 및 생체 특성 등에 관한 
                정보(당해 정보만으로는 특정 개인을 알아볼 수 없는 경우에도 다른 정보와 용이하게 결합하여 알아볼 수 있는 것을 포함)를 말합니다.
            </li>
            <li>
              2. 미즈호전자계약플랫폼, Mizuho electronic Document Platform(이하 MeDP)은 KT Paperless플랫폼을 기반으로 미즈호은행 디지털 전환을 위하여 개발된 서비스입니다. 
                MeDP는 고객님의 개인정보를 중요시하며, 「개인정보 보호법」과 개인정보 보호 관련 각종 법규를 준수하고 있습니다.
            </li>
            <li>
              3. MeDP는 개인정보처리방침을 통하여 고객님의 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.
            </li>
            <li>
              4. MeDP의 개인정보처리방침은 관련 법령 및 내부 운영 방침의 변경에 따라 개정될 수 있습니다. 개인정보처리방침이 개정되는 경우에는 시행일자 등을 부여하여 개정된 내용을 
                홈페이지(<a href="https://medp.mizuhobank.com">https://medp.mizuhobank.com</a>)에 지체 없이 공지합니다.
            </li>
            <li>
              5. 영업의 전부 또는 일부를 양도하거나 합병 등으로 개인정보를 이전하는 경우 서면 전자우편 등을 통하여 고객님께 개별적으로 통지하고, MeDP의 과실 없이 고객님의 
                연락처를 알 수 없는 경우에 해당하여 서면, 전자우편 등으로 통지할 수 없는 경우에는 홈페이지(https://medp.mizuhobank.com), 
                첫 화면에서 식별할 수 있도록 표기하여 30일 이상 그 사실을 공지합니다.
                <font color="#f73E56">
                단, 천재지변 등 정당한 사유로 홈페이지 게시가 곤란한 경우에는 2곳 이상의 중앙일간지(고객님의 대부분이 특정 지역에 거주하는 경우에는 
                그 지역을 보급구역으로 하는 일간지로 할 수 있습니다.)에 1회 이상 공고하는 것으로 갈음합니다.
                </font>
            </li>
          </ul>
        </div>

        <h5>제2조 개인정보의 수집∙이용 목적 및 항목</h5>
        <div>
          <ul>
            <li>
              1. MeDP는 회원가입, 상담, 서비스 제공 등을 위하여 필요한 범위에서 최소한의 개인정보만을 수집합니다.
            </li>
            <li>
              2. 사상, 신념, 가족 및 친인척관계, 학력(學歷)·병력(病歷), 기타 사회활동 경력 등 고객님의 권리 이익이나 사생활을 뚜렷하게 침해할 우려가 있는 개인정보는 수집하지 않습니다. 
              다만, 고객님께서 수집에 동의하시거나 다른 법률에 따라 특별히 수집 대상 개인정보로 허용된 경우에는 필요한 범위에서 최소한으로 위 개인정보를 수집할 수 있습니다.
            </li>
            <li>
              3. MeDP가 수집하는 개인정보 항목과 수집∙이용하는 목적은 다음과 같습니다.
              <h6>가. 필수 수집∙이용 목적 및 항목</h6>
              <div class="basic-table">
                <table>
                  <colgroup>
                    <col width="40%">
                    <col width="60%">
                  </colgroup>
                  <thead>
                    <tr>
                      <th>수집∙이용목적</th>
                      <th>항목</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        서비스 가입/변경/해지, 서비스 이용등록/AS처리, 본인확인, 개인식별, 가입의사확인, 고지사항전달, 
                        서비스제공관련 안내, 가입사실 통보, 서비스 품질개선, 서비스 이용 확인ㆍ점검
                      </td>
                      <td>
                        신청인 성명, 휴대폰 번호, 이메일주소, 아이디, 부서명, 직위
                      </td>
                    </tr>
                  </tbody>
                </table>
                ※ 위 정보는 가입 당시 정보뿐만 아니라 정보 수정으로 변경된 정보를 포함합니다.
              </div>
            </li>
            <li>
              4. MeDP는 아래의 경우에 한하여 고객님의 동의 없이 고객님의 개인정보를 수집∙이용할 수 있습니다.
            </li>
            <li>
              <ul class="s-list">
                <li>
                  가. 고객님과의 계약을 이행하기 위하여 필요한 개인정보로서 경제적∙기술적인 사유로 통상적인 동의를 받는 것이 뚜렷하게 곤란한 경우
                </li>
                <li>
                  나. 서비스의 제공에 따른 요금정산을 위하여 필요한 경우
                </li>
                <li>
                  다. 관련 법령에 특별한 규정이 있는 경우
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제3조 개인정보의 수집방법</h5>
        <div class="m-t">
          <ul>
            <li>
              MeDP는 다음과 같은 방법으로 개인정보를 수집합니다.
            </li>
            <li>
              <ul class="s-list">
                <li>
                  가. 고객사 대표자에게 가입신청서를 전자우편을 통한 수집
                </li>
                <li>
                  나. 가입신청서내 홈페이지 이용 대상 직원 리스트 포함
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제4조 개인정보의 보유 및 이용기간</h5>
        <div>
          <ul>
            <li>
              1. MeDP는 고객님의 개인정보를 고객님께 서비스를 제공하는 기간 또는 분쟁처리 기간 동안에 한하여 보유하고 이를 이용합니다.
              <ul class="s-list">
                <li>
                  가. 서비스 가입기간(가입일 ~ 해지일)
                </li>
                <li>
                  나. 요금정산, 요금 과오납 등 분쟁 대비를 위해 서비스 이용 후 6개월까지
                </li>
                <li>
                  다. 요금관련 분쟁 등 서비스 이용과 관련된 민원/분쟁이 계속될 경우에는 민원/분쟁 해결 시까지 보유(단, 관계 법령에 특별한 규정이 있을 경우 관련 법령에 따라 보관)
                </li>
              </ul>
            </li>
            <li>
              2. 상법, 국세기본법, 통신비밀보호법, 전자상거래 등에서의 소비자보호에 관한 법률, 신용정보의 이용 및 보호에 관한 법률 등 관계법령에 따라 보존할 필요가 있는 경우 
              회사는 관계법령에서 정한 기간 동안 고객의 개인정보를 보유하며, 그 기간은 다음과 같습니다.
            </li>
            <li>
              <div class="basic-table">
                <table>
                  <colgroup>
                    <col width="25%">
                    <col width="60%">
                    <col width="15%">
                  </colgroup>
                  <thead>
                    <tr>
                      <th>보존 근거</th>
                      <th>보존 대상</th>
                      <th>보존 기간</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th rowspan="2">상법</th>
                      <td>상업장부와 영업에 관한 중요서류에 포함된 개인정보</td>
                      <td style="text-align: center;">10년</td>
                    </tr>
                    <tr>
                      <td>전표 또는 이와 유사한 서류에 포함된 개인정보</td>
                      <td style="text-align: center;">5년</td>
                    </tr>
                    <tr>
                      <th>국세기본법</th>
                      <td>성명, 주민번호, 전화번호, 청구지 주소, 요금납부내역 등 거래에 관한 장부 및 증거서류</td>
                      <td style="text-align: center;">5년</td>
                    </tr>
                    <tr>
                      <th rowspan="2">통신비밀보호법</th>
                      <td>통신사실확인자료 제공에 필요한 성명, 주민번호, 전화번호 및 가입자의 전기통신일시, 전기통신개시ㆍ종료시간, 발ㆍ착신 통신번호 등 상대방의 가입자번호, 사용도수, 발신기지국의 위치정보</td>
                      <td style="text-align: center;">12개월<br />
                        <font style="font-size: 0.5rem !important;">단, 시외/시내전화 역무와 관련된 자료 : 6개월</font>
                      </td>
                    </tr>
                    <tr>
                      <td>컴퓨터통신 또는 인터넷의 로그기록자료, 정보통신기기의 위치를 확인할 수 있는 접속지의 추적자료</td>
                      <td style="text-align: center;">3개월</td>
                    </tr>
                    <tr>
                      <th rowspan="4">전자상거래 등에서의 <br>소비자보호에 관한 법률<br>
                      (전자상거래법)</th>
                      <td>계약 또는 청약철회 등에 관한 기록</td>
                      <td style="text-align: center;">5년</td>
                    </tr>
                    <tr>
                      <td>대금결제 및 재화 등의 <br>공급에 관한 기록</td>
                      <td style="text-align: center;">5년</td>
                    </tr>
                    <tr>
                      <td>소비자의 불만 또는 <br>분쟁처리에 관한 기록</td>
                      <td style="text-align: center;">3년</td>
                    </tr>
                    <tr>
                      <td>표시/광고에 관한 기록</td>
                      <td style="text-align: center;">6개월</td>
                    </tr>
                    <tr>
                      <th>신용정보의 이용 및 <br>보호에 관한 법률</th>
                      <td>신용정보의 수집/처리 및 이용 등에 관한 기록</td>
                      <td style="text-align: center;">3년</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
          </ul>
        </div>


        <h5>제5조 개인정보의 파기절차 및 방법</h5>
        <div class="m-t">
          <span>
            MeDP는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 파기절차 및 방법은 다음과 같습니다.
          </span>
          <ul>
            <li>
              1. 파기절차
              <ul class="s-list">
                <li>
                  가. 고객님의 개인정보는 수집 및 이용목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유(보유 및 이용기간 참조)에 따라 일정 기간 저장된 후 파기됩니다.
                </li>
                <li>
                  나. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우와 재가입시 가입비 면제 대상여부를 확인하는 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.
                </li>
              </ul>
            </li>
            <li>
              2. 파기방법
              <ul class="s-list">
                <li>
                  가. 종이(서면)에 작성·출력된 개인정보 : 분쇄하거나 소각 등의 방법으로 파기
                </li>
                <li>
                  나. DB 등 전자적 파일 형태로 저장된 개인정보 : 재생할 수 없는 기술적 방법으로 삭제
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제6조 수집한 개인정보의 공유 및 제공</h5>
        <div>
          <ul>
            <li>
              1. MeDP는 고객님의 사전 동의 없이 고객님의 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우는 예외로 합니다.
              <ul class="s-list">
                <li>가. 요금정산을 위하여 필요한 경우</li>
                <li>나. 관련 법령(통신비밀보호법, 전기통신사업법, 국세기본법 등)에 특별한 규정이 있는 경우로서, 법령에 정해진 규정과 절차에 따라 제공하는 경우</li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제7조 개인정보 처리의 위탁</h5>
        <div>
          MeDP는 서비스 제공에 관한 계약을 이행하고 고객님의 편의 증진 등을 위하여 개인정보 처리업무를 외부 전문업체에게 위탁하고 있으며, 
          수탁자에 대해서는 “위∙수탁계약서” 등을 통하여 관련 법규 및 지침의 준수, 정보보호 및 비밀유지, 제3자 제공 금지, 사고 시 책임부담, 
          위탁기간 종료 즉시 개인정보의 반납/파기 의무 등 책임에 관한 사항을 규정하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
          <ul>
            <li class="m-t">
              [개인정보 처리업무 수탁자 및 위탁 업무 내용]
              <div class="basic-table">
                <table class="center">
                  <colgroup>
                    <col width="34%">
                    <col width="34%">
                    <col>
                  </colgroup>
                  <thead>
                    <tr>
                      <th>수탁사</th>
                      <th>위탁 업무 내용</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>주식회사 케이원</td>
                      <td>전자계약(전자청약)/전자등기/전자문서보관 서비스 개발, 시스템 운영 A/S 등 유지보수</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
            <li>
              ※ 수탁사 리스트는 해당 서비스 변경 및 계약기간에 따라 변경될 수 있습니다.
            </li>
          </ul>
        </div>

        <h5>제8조 이용자 및 법정대리인의 권리와 그 행사 방법</h5>
        <div>
          <ul>
            <li>
              1. 고객님께서는 언제든지 개인정보, 개인정보를 이용하거나 제3자에게 제공한 현황, 개인정보 수집∙이용∙제공 등의 동의를 한 현황(이하 ‘개인정보 등’이라 합니다)에 대한 열람이나 제공을 요구하실 수 있고, 오류가 있는 경우에는 그 정정을 요구하실 수 있으며, 개인정보의 수집∙이용∙제공에 대한 동의를 철회를 하실 수 있습니다.
            </li>
            <li>
              2. 고객님의 개인정보 등에 대한 열람 및 정정을 위해서는 고객님(법정대리인)께서 회사를 직접 방문하시거나 고객센터로 전화 문의 또는 홈페이지 내 ‘정보수정’을 클릭하여 직접 열람 및 정정(선택적 동의철회 포함)을 하실 수 있습니다.
            </li>
            <li>
              3. 고객님께서 본인의 개인정보 등에 대한 열람이나 정정을 요구하시거나 개인정보 수집∙이용∙제공 등의 동의를 철회하시는 경우 고객님의 신분을 증명할 수 있는 주민등록증, 여권, 운전면허증(신형) 등의 신분증명(사본)을 제시 받아 본인 여부를 확인합니다.
            </li>
            <li>
              4. 고객님의 대리인이 고객님의 개인정보 등에 대한 열람이나 정정을 요구하거나 고객님의 개인정보의 수집∙이용∙제공에 대한 동의를 철회하는 경우에는 대리 관계를 나타내는 위임장, 명의고객님의 인감증명서와 대리인의 신분증명서 등의 증표를 제시 받아 적법한 대리인인지 여부를 확인합니다.
            </li>
            <li>
              5. 고객님께서는 개인정보 등의 열람이나 제공을 요청하실 수 있으며, MeDP는 이러한 요청에 지체 없이 필요한 조치를 취합니다.
            </li>
            <li>
              6. 고객님께서 개인정보 등의 오류에 대한 정정을 요청하신 경우에는 지체 없이 그 오류를 정정하거나 정정하지 못하는 사유를 이용자에게 알리는 등 필요한 조치를 하고, 필요한 조치를 할 때까지는 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다. 다만, 다른 법률에 따라 개인정보의 제공을 요청 받은 경우에는 그 개인정보를 제공하거나 이용할 수 있습니다.
            </li>
            <li>
              7. MeDP는 고객님의 요청에 의해 해지 또는 삭제된 개인정보를 “개인정보의 보유 및 이용기간”에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.
            </li>
          </ul>
        </div>

        <h5>제9조 개인정보 자동 수집장치의 설치 운영 및 그 거부에 관한 사항</h5>
        <div>
          MeDP는 홈페이지 운영에 있어 필요 시 고객님의 정보를 찾아내고 저장하는 &#39;쿠키(Cookie)&#39;를
          운용합니다. 쿠키는 MeDP의 웹사이트를 운영하는데 이용되는 서버가 고객님의 브라우저에 보내는
          아주 작은 텍스트 파일로서 고객님의 컴퓨터 하드디스크에 저장됩니다. 고객님께서는 웹브라우저의
          보안 정책을 통해 쿠키에 의한 정보수집의 허용 거부 여부를 결정하실 수 있습니다.
          <ul>
            <li>
              1. 쿠키에 의해 수집되는 정보 및 이용 목적 
            </li>
            <li>
              <ul class="s-list">
                <li>
                  가. 수집 정보 : 고유한 사용자를 식별하기 위해 무작위로 생성된 숫자 세트와 타임스탬프
                </li>
                <li>
                  나. 이용목적 : 회원의 접속빈도나 방문시간 등의 분석을 통해 서비스 이용률 및 관심도를 파악하여 서비스 개편 등의 척도로 활용
                </li>
              </ul>
            </li>
            <li>
              2. 고객님은 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 웹브라우저에서 옵션을 설정함으로써 쿠키에 의한 정보 수집 수준의 선택을 조정하실 수 있습니다.
            </li>
            <li>
              <ul class="s-list">
                <li>
                  가. 웹브라우저의 [도구]메뉴[인터넷옵션][개인정보]에서 쿠키에 의한 정보 수집 수준을 정할 수 있습니다.
                </li>
                <li>
                  나. 위에 제시된 메뉴를 통해 쿠키가 저장될 때마다 확인을 하거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다. 단, 고객님께서 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.
                </li>
              </ul>
            </li>
          </ul>
        </div>


        <h5>제10조 개인정보의 기술적, 관리적 보호</h5>
        <div>
          MeDP는 고객님의 개인정보가 분실, 도난, 유출, 위조∙변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적∙관리적 대책을 마련하고 있습니다.
          <ul class="m-t">
            [기술적 보호대책]
            <li>
              1. 고객님의 개인정보를 암호화하여 저장하며, 정보통신망을 통해 고객님의 개인정보 및 인증정보를 송∙수신 하는 경우에는 안전한 보안서버 구축 등의 조치를 통해 암호화 하여 보호하고 있습니다.
            </li>
            <li>
              2. 백신 소프트웨어를 이용하여 컴퓨터바이러스 등에 의한 피해를 방지하기 위한 조치를 취하고 있습니다. 백신 소프트웨어는 주기적으로 업데이트되며 갑작스런 바이러스가 출현할 경우 백신이 나오는 즉시 이를 도입, 적용함으로써 개인정보가 침해되는 것을 방지하고 있습니다.
            </li>
            <li>
              3. 고객님의 개인정보에 대한 불법적인 접근을 차단하기 위해, 외부로부터 접근이 통제된 구역에 시스템을 설치하고, 침입을 차단하는 장치를 이용하고 있으며, 아울러 침입탐지시스템을 설치하여 24시간 침입을 감시하고 있습니다.
            </li>
          </ul>
          <ul class="m-t">
            [관리적 보호대책]
            <li>
              1. MeDP는 고객님의 개인정보를 안전하게 처리하기 위한 내부관리계획을 마련하여 소속 직원이 이를 숙지하고 준수하도록 하고 있습니다.
            </li>
            <li>
              2. MeDP는 고객님의 개인정보를 처리할 수 있는 자를 최소한으로 제한하고 접근 권한을 관리하며, 새로운 보안 기술 습득 및 개인정보보호 의무 등에 관해 정기적인 사내 교육과 외부 위탁교육을 통하여 법규 및 정책을 준수할 수 있도록 하고 있습니다. 고객님의 개인정보를 처리하는 자는 다음과 같습니다.
              <ul class="s-list">
                <li>가. 고객님을 직·간접적으로 상대하여 마케팅 업무를 수행하는 자</li>
                <li>나. 개인정보 보호책임자 및 개인정보 보호담당자 등 개인정보 관리 및 개인정보보호 업무를 담당하는 자</li>
                <li>다. 기타 업무상 개인정보의 처리가 불가피한 자</li>
              </ul>
            </li>
            <li>
              3. 전 임직원이 정보보호서약서에 서명하게 함으로써 직원에 의한 정보(개인정보 포함)유출을 사전에 방지하고, 수시로 개인정보보호 의무를 상기시키며 준수 여부를 감사하기 위한 내부 절차를 마련하여 시행하고 있습니다.
            </li>
            <li>
              4. 개인정보취급자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이루어지도록 하여, 입사 및 퇴사 후 개인정보 침해사고에 대한 책임을 명확하게 규정하고 있습니다.4. 개인정보취급자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이루어지도록 하여, 입사 및 퇴사 후 개인정보 침해사고에 대한 책임을 명확하게 규정하고 있습니다.
            </li>
            <li>
              5. 전산실 및 자료보관실 등을 통제구역으로 설정하여 출입을 통제합니다.
            </li>
            <li>
              6. MeDP는 고객님 개인의 실수나 기본적인 인터넷의 위험성 때문에 일어나는 일들에 대해 책임을 지지 않습니다. 고객님의 개인정보를 보호하기 위해서 자신의 ID와 비밀번호를 철저히 관리하고 책임을 져야 합니다.
            </li>
          </ul>
        </div>

        <h5>제11조 개인정보 보호책임 부서 및 연락처</h5>
        <div>
          MeDP는 고객님의 개인정보를 보호하고 개인정보와 관련한 불만 및 문의사항을 처리하기 위하여 아래와 같이 관련 부서를 지정하여 운영하고 있습니다. 또한 고객님의 의견을 매우 소중하게 생각합니다. 고객님께서 MeDP서비스의 개인정보 관련 문의사항이 있을 경우 아래 개인정보 보호책임자 및 담당자에게 문의하시면 신속하고 성실하게 답변을 드리겠습니다.
          <ul class="m-t">
            <li>
              1. 개인정보 보호책임 부서 및 연락처
              <ul class="s-list">
                <li>
                  가. MeDP 개인정보 보호책임자 : KT Blockchain사업담당 심재희 담당
                  <div class="m-l">
                    ㅇ 전화번호: 080-318-5306<br>
                    ㅇ 이메일 : jaehee.shim@kt.com
                  </div>
                </li>
                <li>
                  나. MeDP 개인정보 보호담당자 : KT Blockchain사업담당 페이퍼리스DX 사업TF 김태희 팀장
                  <div class="m-l">
                    ㅇ 전화번호: 080-318-5306<br>
                    ㅇ 이메일 : karosero.kim@kt.com
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제12조 개인정보 열람청구</h5>
        <div>
          MeDP는 고객님의 개인정보 열람 청구를 위하여 아래와 같이 관련 부서를 지정하여 운영하고 있습니다. 
          고객님께서 MeDP서비스에 개인정보 열람을 청구하실 경우 아래 부서 담당자에게 문의하시면 신속하고 성실하게 답변 드리겠습니다.
          <ul class="m-t">
            <li>
              [MeDP 개인정보 열람청구 접수∙처리 부서]
              <ul class="s-list">
                <li class="m-l">
                  가. 부서명 : KT Blockchain사업담당 페이퍼리스DX 사업TF
                </li>
                <li class="m-l">
                  나. 담당자 : 신현호 차장
                </li>
                <li class="m-l">
                  다. 연락처 : 080-318-5306, hyunho.shin@kt.com
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제13조 권익침해 구제방법</h5>
        <div>
          기타 개인정보 침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하여 주시기 바랍니다.
          <ul class="m-t">
            <li>
              1. 개인정보 침해신고센터 (한국인터넷진흥원 운영)
              <ul>
                <li>가. 소관업무 : 개인정보 침해사실 신고, 상담 신청</li>
                <li>나. 홈페이지/전화 : http://privacy.kisa.or.kr / (국번없이) 118</li>
              </ul>
            </li>
            <li>
              2. 개인정보 분쟁조정위원회
              <ul>
                <li>가. 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)</li>
                <li>나. 홈페이지/전화 : www.kopico.go.kr / (국번없이) 1833-6972</li>
              </ul>
            </li>
            <li>3. 대검찰청 사이버수사과 : www.spo.go.kr / (국번없이) 1301</li>
            <li>4. 경찰청 사이버안전국 : https://ecrm.police.go.kr / (국번없이) 182</li>
          </ul>
        </div>

        <h5>제14조 개인정보처리방침 고지</h5>
        <div>
          <ul>
            <li>
              1. KT MeDP 개인정보처리방침 공고/시행일자
              <ul class="s-list">
                <li>가. 공고일자 : [2023/06/19]</li>
                <li>나. 시행일자 : [2023/07/01]</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>

    <!-- 이전 개인정보 처리방침 (2023.06.01~2023.06.30 적용, 원본 복원) -->
    <b-modal id="이전정보처리방침_2023" ok-only :ok-title="$t('확인')" :title="$t('개인정보 처리방침')">
      <div class="scroll policy">
        <h5>제1조 총칙</h5>
        <div>
          <ul>
            <li>
              MeDP는 고객님의 개인정보를 소중하게 생각하고 고객님의 개인정보를 효과적으로 관리하고 안전하게 보호하기 위하여 최선의 노력을 다하고 있습니다. 회사는 『개인정보보호법』과 관련 법규를 준수하고 있습니다. 또한 개인정보처리방침을 제정하여 이를 준수하고 있으며, 본 처리방침을 홈페이지에 공개하여 고객님께서 언제나 쉽게 열람하실 수 있도록 하고 있습니다.
            </li>
            <li>
              1. 개인정보란 생존하는 개인에 관한 정보로서 성명, 생년월일, 성별 등에 의하여 당해 개인을 알아볼 수 있는 부호, 문자, 음성, 음향, 영상 및 생체 특성 등에 관한 정보(당해 정보만으로는 특정 개인을 알아볼 수 없는 경우에도 다른 정보와 용이하게 결합하여 알아볼 수 있는 것을 포함)를 말합니다.
            </li>
            <li>
              2. MeDP는 고객님의 개인정보를 중요시하며, 「개인정보 보호법」과 개인정보 보호 관련 각종 법규를 준수하고 있습니다.
            </li>
            <li>
              3. MeDP는 개인정보처리방침을 통하여 고객님의 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.
            </li>
            <li>
              4. MeDP의 개인정보처리방침은 관련 법령 및 내부 운영 방침의 변경에 따라 개정될 수 있습니다. 개인정보처리방침이 개정되는 경우에는 시행일자 등을 부여하여 개정된 내용을 홈페이지(https://medp.mizuhobank.com)에 지체 없이 공지합니다.
            </li>
            <li>
              5. 영업의 전부 또는 일부를 양도하거나 합병 등으로 개인정보를 이전하는 경우 서면 전자우편 등을 통하여 고객님께 개별적으로 통지하고, MeDP의 과실 없이 고객님의 연락처를 알 수 없는 경우에 해당하여 서면, 전자우편 등으로 통지할 수 없는 경우에는 홈페이지(https://medp.mizuhobank.com), 첫 화면에서 식별할 수 있도록 표기하여 30일 이상 그 사실을 공지합니다.<br />
              <font color="#f73E56">단, 천재지변 등 정당한 사유로 홈페이지 게시가 곤란한 경우에는 2곳 이상의 중앙일간지(고객님의 대부분이 특정 지역에 거주하는 경우에는 그 지역을 보급구역으로 하는 일간지로 할 수 있습니다.)에 1회 이상 공고하는 것으로 갈음합니다.</font>
            </li>
          </ul>
        </div>

        <h5>제2조 개인정보의 수집∙이용 목적 및 항목</h5>
        <div>
          <ul>
            <li>
              1. MeDP는 회원가입, 상담, 서비스 제공 등을 위하여 필요한 범위에서 최소한의 개인정보만을 수집합니다.
            </li>
            <li>
              2. 사상, 신념, 가족 및 친인척관계, 학력(學歷)·병력(病歷), 기타 사회활동 경력 등 고객님의 권리 • 이익이나 사생활을 뚜렷하게 침해할 우려가 있는 개인정보는 수집하지 않습니다. 다만, 고객님께서 수집에 동의하시거나 다른 법률에 따라 특별히 수집 대상 개인정보로 허용된 경우에는 필요한 범위에서 최소한으로 위 개인정보를 수집할 수 있습니다.
            </li>
            <li>
              3. MeDP가 수집하는 개인정보 항목과 수집∙이용하는 목적은 다음과 같습니다.
              <h6>가. 필수 수집∙이용목적 및 항목</h6>
              <div class="basic-table">
                <table>
                  <colgroup>
                    <col width="40%">
                    <col width="60%">
                  </colgroup>
                  <thead>
                    <tr>
                      <th>수집∙이용목적</th>
                      <th>항목</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        서비스 가입/변경/해지, 서비스 이용등록/AS처리, 본인확인, 개인식별, 가입의사확인, 고지사항전달, 서비스제공관련 안내, 가입사실 통보, 서비스 품질개선, 서비스 이용 확인ㆍ점검  
                      </td>
                      <td>
                        신청인 성명, 휴대폰 번호, 이메일주소
                      </td>
                    </tr>
                  </tbody>
                </table>
                ※ 위 정보는 가입 당시 정보뿐만 아니라 정보 수정으로 변경된 정보를 포함합니다.
              </div>
            </li>
          </ul>
        </div>

        <h5>제3조 개인정보의 수집방법</h5>
        <div class="m-t">
          <span>
            MeDP는 다음과 같은 방법으로 개인정보를 수집합니다.
          </span>
          <ul>
            <li>
              가. 고객사 대표자에게 가입신청서를 전자우편을 통한 수집
            </li>
            <li>
              나. 가입신청서내 홈페이지 이용 대상 직원 리스트 포함(제2조 3항)
            </li>
          </ul>
        </div>

        <h5>제4조 개인정보의 보유 및 이용기간</h5>
        <div>
          <ul>
            <li>
              1. 회사는 고객님의 개인정보를 고객님께 서비스를 제공하는 기간 또는 분쟁처리 기간 동안에 한하여 보유하고 이를 이용합니다.
              <ul class="s-list">
                <li>
                  가. 서비스 이용기간 동안(가입일~해지일) 및 이용 후 6개월까지
                </li>                
              </ul>
            </li>
            <li>
              2. 상법, 국세기본법, 통신비밀보호법, 전자상거래 등에서의 소비자보호에 관한 법률, 신용정보의 이용 및 보호에 관한 법률 등 관계법령에 따라 보존할 필요가 있는 경우 회사는 관계법령에서 정한 기간 동안 고객의 개인정보를 보유하며, 그 기간은 다음과 같습니다.
            </li>
            <li>
              <div class="basic-table">
                <table>
                  <colgroup>
                    <col width="25%">
                    <col width="60%">
                    <col width="15%">
                  </colgroup>
                  <thead>
                    <tr>
                      <th>보존 근거</th>
                      <th>보존 대상</th>
                      <th>보존 기간</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th rowspan="2">상법</th>
                      <td>상업장부와 영업에 관한 중요서류에 포함된 개인정보</td>
                      <td style="text-align: center;">10년</td>
                    </tr>
                    <tr>
                      <td>전표 또는 이와 유사한 서류에 포함된 개인정보</td>
                      <td style="text-align: center;">5년</td>
                    </tr>
                    <tr>
                      <th>국세기본법</th>
                      <td>성명, 전화번호, 청구지 주소, 요금납부내역(청구액, 수납액, 수납일시, 요금납부방법) 등 거래에 관한 장부 및 증거서류</td>
                      <td style="text-align: center;">5년</td>
                    </tr>
                    <tr>
                      <th rowspan="2">통신비밀보호법</th>
                      <td>통신사실확인자료 제공에 필요한 성명, 전화번호 및 가입자의 전기통신일시, 전기통신 개시•종료시간, 발•착신 통신번호 등 상대방의 가입자 번호, 사용도수, 발신 기지국의 위치정보</td>
                      <td style="text-align: center;">12개월</td>
                    </tr>
                    <tr>
                      <td>컴퓨터통신 또는 인터넷의 로그기록자료, 정보통신기기의 위치를 확인할 수 있는 접속지의 추적 자료</td>
                      <td style="text-align: center;">3개월</td>
                    </tr>
                    <tr>
                      <th rowspan="4">전자상거래 등에서의 <br>소비자보호에 관한 법률<br>
                      (전자상거래법)</th>
                      <td>계약 또는 청약철회 등에 관한 기록</td>
                      <td style="text-align: center;">5년</td>
                    </tr>
                    <tr>
                      <td>대금결제 및 재화 등의 <br>공급에 관한 기록</td>
                      <td style="text-align: center;">5년</td>
                    </tr>
                    <tr>
                      <td>소비자의 불만 또는 <br>분쟁처리에 관현 기록</td>
                      <td style="text-align: center;">3년</td>
                    </tr>
                    <tr>
                      <td>표시/광고에 관한 기록</td>
                      <td style="text-align: center;">6개월</td>
                    </tr>
                    <tr>
                      <th>신용정보의 이용 및 <br>보호에 관한 법률<br>
                      (신용정보법)</th>
                      <td>신용정보의 수집/처리 및 이용 등에 관한 기록</td>
                      <td style="text-align: center;">3년</td>
                    </tr>
                    <tr>
                      <th>부가가치세법</th>
                      <td>
                      <p style="margin: 0px;">사업자 납부세액 또는 환급세액 관련 거래사실 기록장부</p>
                      <p style="margin: 0px;">과세되는 공급, 면세되는 공급 사실 기록장부</p>
                      <p style="margin: 0px;">세금계산서, 수입세금계산서, 영수증</p>
                      </td>
                      <td style="text-align: center;">5년</td>
                    </tr>
                    <tr>
                      <th>근로기준법</th>
                      <td>성명, 성별, 생년월일, 주소, 이력, 종사 업무종료, 고용 또는 고용갱신 연월일, 계약기간 정한 경우 그 기간, 그 밖의 고용관한 사항, 해고 퇴직 또는 사망한 경우 그 일자와 사유 및 그 밖의 필요한 사항</td>
                      <td style="text-align: center;">3년</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
          </ul>
        </div>


        <h5>제5조 개인정보의 파기절차 및 방법</h5>
        <div class="m-t">
          <span>
            MeDP는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 파기절차 및 방법은 다음과 같습니다.
          </span>
          <ul>
            <li>
              1. 파기절차
              <ul class="s-list">
                <li>
                  가. 고객님의 개인정보는 수집 및 이용목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유(보유 및 이용기간 참조)에 따라 일정 기간 저장된 후 파기됩니다.
                </li>
                <li>
                  나. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.
                </li>
              </ul>
            </li>
            <li>
              2. 파기방법
              <ul class="s-list">
                <li>
                  가. 종이(서면)에 작성·출력된 개인정보 : 분쇄하거나 소각 등의 방법으로 파기
                </li>
                <li>
                  나. DB 등 전자적 파일 형태로 저장된 개인정보 : 재생할 수 없는 기술적 방법으로 삭제
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제6조 수집한 개인정보의 공유 및 제공</h5>
        <div>
          <ul>
            <li>
              1. MeDP는 고객님의 사전 동의 없이 고객님의 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우는 예외로 합니다.
              <ul class="s-list">
                <li>가. 관련 법령(통신비밀보호법, 전기통신사업법, 국세기본법 등)에 특별한 규정이 있는 경우로서, 법령에 정해진 규정과 절차에 따라 제공하는 경우</li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제7조 개인정보 처리의 위탁</h5>
        <div>
          MeDP는 서비스 제공에 관한 계약을 이행하고 고객님의 편의 증진 등을 위하여 개인정보 처리업무를 외부 전문업체에게 위탁하고 있으며, 
          수탁자에 대해서는 “위∙수탁계약서” 등을 통하여 관련 법규 및 지침의 준수, 정보보호 및 비밀유지, 제3자 제공 금지, 사고 시 책임부담, 
          위탁기간 종료 즉시 개인정보의 반납/파기 의무 등 책임에 관한 사항을 규정하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
          <ul>
            <li class="m-t">
              [개인정보 처리업무 수탁자 및 위탁 업무 내용]
              <div class="basic-table">
                <table class="center">
                  <colgroup>
                    <col width="34%">
                    <col width="34%">
                    <col>
                  </colgroup>
                  <thead>
                    <tr>
                      <th>수탁사</th>
                      <th>위탁 업무 내용</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>K-ONE</td>
                      <td>전자계약(전자청약)/전자등기/전자문서보관 서비스 개발, 시스템 운영 A/S 등 유지보수</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
            <li>
              ※ 수탁사 리스트는 해당 서비스 변경 및 계약기간에 따라 변경될 수 있습니다.
            </li>
          </ul>
        </div>

        <h5>제8조 이용자 및 법정대리인의 권리와 그 행사 방법</h5>
        <div>
          <ul>
            <li>
              1. 고객님의 대리인이 고객님의 개인정보 등에 대한 열람이나 정정을 요구하거나 고객님의 개인정보의 수집∙이용∙제공에 대한 동의를 철회하는 경우에는 대리 관계를 나타내는 위임장, 명의고객님의 인감증명서와 대리인의 신분증명서 등의 증표를 제시 받아 적법한 대리인인지 여부를 확인합니다.
            </li>
            <li>
              2. 고객님께서는 개인정보 등의 열람이나 제공을 요청하실 수 있으며, MeDP는 이러한 요청에 지체 없이 필요한 조치를 취합니다.
            </li>
            <li>
              3. 고객님께서 개인정보 등의 오류에 대한 정정을 요청하신 경우에는 지체 없이 그 오류를 정정하거나 정정하지 못하는 사유를 이용자에게 알리는 등 필요한 조치를 하고, 필요한 조치를 할 때까지는 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다. 다만, 다른 법률에 따라 개인정보의 제공을 요청 받은 경우에는 그 개인정보를 제공하거나 이용할 수 있습니다.
            </li>
            <li>
              4. MeDP는 고객님의 요청에 의해 해지 또는 삭제된 개인정보를 “개인정보의 보유 및 이용기간”에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.
            </li>
          </ul>
        </div>

        <h5>제9조 개인정보의 기술적, 관리적 보호</h5>
        <div>
          MeDP는 고객님의 개인정보가 분실, 도난, 유출, 위조∙변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적∙관리적 대책을 마련하고 있습니다.
          <ul class="m-t">
            [기술적 보호대책]
            <li>
              1. 고객님의 개인정보를 암호화하여 저장하며, 정보통신망을 통해 고객님의 개인정보 및 인증정보를 송∙수신 하는 경우에는 안전한 보안서버 구축 등의 조치를 통해 암호화 하여 보호하고 있습니다.
            </li>
            <li>
              2. 백신 소프트웨어를 이용하여 컴퓨터바이러스 등에 의한 피해를 방지하기 위한 조치를 취하고 있습니다. 백신 소프트웨어는 주기적으로 업데이트되며 갑작스런 바이러스가 출현할 경우 백신이 나오는 즉시 이를 도입, 적용함으로써 개인정보가 침해되는 것을 방지하고 있습니다.
            </li>
            <li>
              3. 고객님의 개인정보에 대한 불법적인 접근을 차단하기 위해, 외부로부터 접근이 통제된 구역에 시스템을 설치하고, 침입을 차단하는 장치를 이용하고 있으며, 아울러 침입탐지시스템을 설치하여 24시간 침입을 감시하고 있습니다.
            </li>
          </ul>
          <ul class="m-t">
            [관리적 보호대책]
            <li>
              1. MeDP는 고객님의 개인정보를 안전하게 처리하기 위한 내부관리계획을 마련하여 소속 직원이 이를 숙지하고 준수하도록 하고 있습니다.
            </li>
            <li>
              2. MeDP는 고객님의 개인정보를 처리할 수 있는 자를 최소한으로 제한하고 접근 권한을 관리하며, 새로운 보안 기술 습득 및 개인정보보호 의무 등에 관해 정기적인 사내 교육과 외부 위탁교육을 통하여 법규 및 정책을 준수할 수 있도록 하고 있습니다. 고객님의 개인정보를 처리하는 자는 다음과 같습니다.
              <ul class="s-list">
                <li>가. 고객님을 직·간접적으로 상대하여 마케팅 업무를 수행하는 자</li>
                <li>나. 개인정보 보호책임자 및 개인정보 보호담당자 등 개인정보 관리 및 개인정보보호 업무를 담당하는 자</li>
                <li>다. 기타 업무상 개인정보의 처리가 불가피한 자</li>
              </ul>
            </li>
            <li>
              3. 전 임직원이 정보보호서약서에 서명하게 함으로써 직원에 의한 정보(개인정보 포함)유출을 사전에 방지하고, 수시로 개인정보보호 의무를 상기시키며 준수 여부를 감사하기 위한 내부 절차를 마련하여 시행하고 있습니다.
            </li>
            <li>
              4. 개인정보취급자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이루어지도록 하여, 입사 및 퇴사 후 개인정보 침해사고에 대한 책임을 명확하게 규정하고 있습니다.
            </li>
            <li>
              5. 전산실 및 자료보관실 등을 통제구역으로 설정하여 출입을 통제합니다.
            </li>
            <li>
              6. 서비스 이용계약 체결 또는 서비스 제공을 위하여 고객님의 은행결제계좌, 신용카드번호 등 대금결제에 관한 정보를 수집하거나 고객님께 제공하는 경우 해당 고객님이 본인임을 확인하기 위하여 필요한 조치를 취하고 있습니다.
            </li>
            <li>
              7. MeDP는 고객님 개인의 실수나 기본적인 인터넷의 위험성 때문에 일어나는 일들에 대해 책임을 지지 않습니다. 고객님의 개인정보를 보호하기 위해서 자신의 ID와 비밀번호를 철저히 관리하고 책임을 져야 합니다.
            </li>
          </ul>
        </div>

        <h5>제10조 개인정보 보호책임 부서 및 연락처</h5>
        <div>
          MeDP는 고객님의 개인정보를 보호하고 개인정보와 관련한 불만 및 문의사항을 처리하기 위하여 아래와 같이 관련 부서를 지정하여 운영하고 있습니다. 또한 고객님의 의견을 매우 소중하게 생각합니다. 고객님께서 MeDP서비스의 개인정보 관련 문의사항이 있을 경우 아래 개인정보 보호책임자 및 담당자에게 문의하시면 신속하고 성실하게 답변을 드리겠습니다.
          <ul class="m-t">
            <li>
              1. 개인정보 보호책임 부서 및 연락처
              <ul class="s-list">
                <li>
                  가. KT Paperless 서비스 개인정보 보호책임자 : KT Blockchain사업담당 심재희 담당
                  <div class="m-l">
                    ㅇ 전화번호: 080-318-5306<br>
                    ㅇ 이메일 : jaehee.shim@kt.com
                  </div>
                </li>
                <li>
                  나. KT Paperless 서비스 개인정보 보호담당자 : KT Blockchain사업담당 도큐먼트DX 사업팀 김태희 팀장
                  <div class="m-l">
                    ㅇ 전화번호: 080-318-5306<br>
                    ㅇ 이메일 : karosero.kim@kt.com
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제11조 개인정보 열람청구</h5>
        <div>
          MeDP는 고객님의 개인정보 열람 청구를 위하여 아래와 같이 관련 부서를 지정하여 운영하고 있습니다. 고객님께서 MeDP서비스에 개인정보 열람을 청구하실 경우 아래 부서 담당자에게 문의하시면 신속하고 성실하게 답변 드리겠습니다.
          <ul class="m-t">
            <li>
              [MeDP 개인정보 열람청구 접수∙처리 부서]
              <ul class="s-list">
                <li class="m-l">가. 부서명 : KT Blockchain사업담당 도큐먼트DX 사업팀</li>
                <li class="m-l">나. 담당자 : 황산하 과장</li>
                <li class="m-l">다. 연락처 : 080-318-5306 / sana.hwang@kt.com</li>
              </ul>
            </li>
          </ul>
        </div>

        <h5>제12조 권익침해 구제방법</h5>
        <div>
          기타 개인정보 침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하여 주시기 바랍니다.
          <ul class="m-t">
            <li>
              1. 개인정보 침해신고센터 (한국인터넷진흥원 운영)
              <ul>
                <li>가. 소관업무 : 개인정보 침해사실 신고, 상담 신청</li>
                <li>나. 홈페이지/전화 : http://privacy.kisa.or.kr / (국번없이) 118</li>
              </ul>
            </li>
            <li>
              2. 개인정보 분쟁조정위원회
              <ul>
                <li>가. 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)</li>
                <li>나. 홈페이지/전화 : www.kopico.go.kr / (국번없이) 1833-6972</li>
              </ul>
            </li>
            <li>3. 대검찰청 사이버수사과 : www.spo.go.kr / (국번없이) 1301</li>
            <li>4. 경찰청 사이버안전국 : cyberbureau.police.go.kr / (국번없이) 182</li>
          </ul>
        </div>

        <h5>제13조 개인정보처리방침 고지</h5>
        <div>
          <ul>
            <li>
              1. MeDP 개인정보처리방침 공고/시행일자
              <ul class="s-list">
                <li>가. 공고일자 : [2023/05/31]</li>
                <li>나. 시행일자 : [2023/06/01]</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>



    <div class="select-lang">
      <b-form-select size="sm" @change="lang => $store.commit('settings', { lang })" :value="settings.lang"
        :options="$code('LANG')" />
    </div>
  </div>
  <!-- mode: done -->
  <div v-else class="center-middle bg-banner kind">
    <div v-if="user.availAdm == 'Y'" @click="go('adm')">
      <b-icon icon="person-lines-fill" />
      <h2 v-text="$t('관리자 화면')" />
    </div>
    <div :key="i" v-for="({ custName, custId }, i) in user.custList" @click="go('main', custId)">
      <b-icon icon="newspaper" /><br>
      <h2 v-text="custName" />
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    devMode: ['localhost', 'medp-dev'].includes(location.hostname.split('.')[0]),
    window, //capcha: {}, capchaForm: {},
    mode: 'login', agree: false,
    form: { userId: '', password: '' },
    pwd: { pwd: '', pwdConf: '', svcAgreeYn: 'Y' },
    find: { userId: '', userNm: '', email: '' },
  }),
  computed: {
    user() { return this.$store.state.user },
    settings() { return this.$store.state.settings },
  },
  watch: { mode: 'setMode' },
  async created() {
    //if (!this.user.kind) this.getCapcha();
  },
  methods: {
    async setCheckAction() {
      await this.$delay(1000);
      const agree = document.querySelector('iframe').contentWindow.agree;
      agree.checked = this.agree;
      agree.onchange = (e) => {
        this.agree = e.target.checked;
        if (this.agree) this.$bvModal.hide('설명');
      };
    },
    /*
    async getCapcha() {
      this.capcha = await this.$api('/captcha/call');
    },*/
    playCapcha() {
      (new Audio(this.capcha.capSoundUrl)).play();
    },
    setMode(mode) {
      const { custList, availAdm } = this.user;
      if (mode == 'done')
        if (availAdm != 'Y' && custList && custList.length == 1)
          this.go('main', custList[0].custId);
        else if (availAdm != 'Y' && (!custList || custList.length == 0)) {
          this.$alert(this.$t('조직 정보를 찾을 수 없습니다.'));
          this.mode = 'login';
        }
    },
    async login() {
      this.mode = "login...";
      try {

        /*
        if (!this.capchaForm.chkCode) throw this.$t('인증번호 항목을 입력하세요');
        this.capchaForm.insId = this.capcha.capInsId;
        const { captchaToken } = await this.$api('/captcha/check', this.capchaForm);
        if(!captchaToken) {
          throw this.$t('인증번호를 다시 입력해 주세요.');
        }
        this.form.captchaToken = captchaToken || '';
        */

         // Google reCAPTCHA v3 토큰 생성

        //await this.$recaptchaLoaded();
        //const captchaToken = await this.$recaptcha('login');

        // Google reCAPTCHA v3 토큰 생성 (폐쇄망 타임아웃 적용)
        let captchaToken = '';
        try {
          await Promise.race([
            this.$recaptchaLoaded(),
            new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), 2000))
          ]);
          captchaToken = await this.$recaptcha('login');
        } catch (e) {
          console.warn('reCAPTCHA 로드 실패 (사내망으로 판단):', e.message);
          captchaToken = '';
        }



        const form = { ...this.form };
        const rsaEnc = await this.$rsaEnc([form.userId, form.password]);
        form.userId = rsaEnc[0];
        form.password = rsaEnc[1];
        form.userLang = this.settings.lang;

        //구글 캡챠 추가
        form.captchaToken = captchaToken;  // 이 줄 추가

        const res = await this.$api('login', form);        
        this.mode = "login";        
        if (!res.success) {
          return this.$alert(res.msg);
        } else {
          await this.$store.commit('user');
          this.$store.commit('user', res.data);
          const { data } = await this.$api('adm/selectLoginUser', { refreshToken: res.data.refreshToken, pwd: rsaEnc[1] });
          this.$store.commit('settings', {lang:data.userLang});
          this.$setCodes(data.userLang);
          this.$setFileTypes();
          data.img = data.userImgFileUrl ? this.$url(data.userImgFileUrl) : '/img/user.webp';
          data.lastAccessDt = (new Date()).toISOString().f('datetime-local');
          this.$store.commit('user', data);
          this.agree = data.svcAgreeYn == 'Y';
          if(res.code == -1) {
            this.$alert(res.msg);
            this.mode = 'changepw';
          } else {
            this.mode = data.svcAgreeYn == 'N' || data.pwdChgYn == 'N' ? 'changepw' : 'done';
          }
        }
      }
      catch (e) {
        if (typeof e === 'string') {
          if(await this.$alert(e + '')) {
            setTimeout(() => {
              this.$refs.captchaInput.focus();
            }, 300);
          }
        }
        this.mode = "login";
        
        //this.capchaForm.chkCode = '';
        //this.getCapcha();
      }
    },
    async go(kind, custId) {
      if (!this.$router.options.routes.find(({ meta, path }) => meta && meta.kind == kind && path == this.$route.path))
        this.$go(this.$router.options.routes.find(({ meta }) => meta && meta.kind == kind).path);
      let { accessToken, refreshToken } = this.user;
      const { data: { accessToken: a, refreshToken: r, user: u } } = await this.$api(kind == 'main' ? 'main/enterMain' : 'adm/enterAdm', { accessToken, refreshToken, custId: kind != 'main' ? '' : custId });
      await this.$store.commit('user', { accessToken: a, refreshToken: r, kind, custId, auths: u.auths, grpId: u.grpId });
      this.$parent.$forceUpdate();
    },
    async changeInitPwd() {
      const { pwd, pwdConf } = this.pwd;
      const msg = !/.{4,}/.test(pwd) && '비밀번호는 4자이상으로 입력하세요' ||
        pwd == this.form.password && '기존 비밀번호와 달라야 합니다.' ||
        pwd != pwdConf && '비밀번호가 일치하지 않습니다.';
      if (msg) return this.$alert(this.$t(msg));
      const form = { svcAgreeYn: 'Y' };
      form.pwd = form.pwdConf = (await this.$rsaEnc([pwd]))[0];
      const res = await this.$api('cmm/changeInitPwd', form);
      if (!res.success) {
        return this.$alert(res.msg);
      } else {
        if(await this.$alert(res.msg)) {
          this.mode = 'done';
        }
      }
    },
    async findIdPwd(mode) {
      const { email, userId, userNm } = this.find;
      const msg = !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email) && '이메일 형식을 확인하세요' ||
        mode == 'Pwd' && !userId && '아이디를 입력하세요' ||
        mode == 'Id' && !userNm && '이름을 입력하세요';
      if (msg) return this.$alert(this.$t(msg));
      const res = await this.$api('findUser' + mode, this.find);
      await this.$alert(res.msg);
      if (res.success) {
        if (mode == 'Id' && res.data) this.form.userId = res.data;
        this.mode = 'login';
      }
    },
  },
}
/*
/cmm/user/changeUserPwd	""pwd": "12",
"pwdConf": "12""
*/
</script>

<style>
label {
  cursor: pointer;
}

.bg-banner {
  background: url(/img/mizuhoglobal_Banner.jfif) no-repeat center center / cover;
}

.kind svg {
  font-size: 400%;
  margin-bottom: 1rem;
}

.kind>div {
  cursor: pointer;
  opacity: 0.8;
  background-color: var(--kt-card-bg);
  box-shadow: 0 0 10px #777;
  border-radius: 20px;
  padding: 50px 0;
  margin: 0 2vw;
  width: 170px;
  text-align: center;
}

.select-lang {
  position: fixed;
  inset: auto calc(100% - 100px) 6px 9px;
  z-index: 1;
  background-color: #fff;
}
</style>